import { Box, Typography, Grid, Tooltip, Table, TableHead, TableRow, TableCell, TableBody, IconButton, InputAdornment, MenuItem } from "@mui/material"
import Loading from "component/Loading"
import CheckboxButton from "new-components/buttons/checkbox-button"
import MainButton from "new-components/buttons/main-button"
import RadioButton from "new-components/buttons/radio-button"
import DateInput from "new-components/inputs/date-input"
import TextAreaInput from "new-components/inputs/text-area-input"
import TextInput from "new-components/inputs/text-input"
import { useHistory, useLocation } from "react-router-dom"
import { routeName } from "routes/routes-name"
import InfoIcon from '@mui/icons-material/Info'
import SelectInput from "new-components/inputs/select-input"
import { useEffect, useRef, useState } from "react"
import { format } from 'date-fns'
import VoucherApi from "api/voucher/voucher.api"
import _ from "lodash"
import SnackbarComponent from "new-components/snackbar/snackbar-component"
import OperativeTypeApi from "api/setting/treatments/operative-type.api"
import ProductTypesApi from "api/setting/default-products/product-type.api"
import OperativeApi from "api/setting/treatments/operative.api"
import { getBranch } from "utils/app.utils"
import ProductsApi from "api/warehouses/product.api"
import ButtonExport from "component/Button/ButtonExport"
import AddCircleIcon from '@mui/icons-material/AddCircle'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import TableCustom from "component/Table/TableCustom"
import TableRowCommon from "component/Table/TableRowCommon"
import { dateToView } from "utils/date.utils"
import DateRangeInput from "new-components/inputs/date-range-input"
import PageModal from "new-components/modal/page-modal"
import SelectCheckBoxInput from "new-components/inputs/select_checkbox_input"
import ComponentApi from "api/components-api"
import AlertModal from "new-components/modal/alert-modal"
import moment from "moment"
import { icons } from "constants/images"
import TableRowExport from "component/Pdf/TableRowExport"
import AutocompleteSelect from "component/Select/AutocompleteSelect"
import ClearIcon from '@mui/icons-material/Clear'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import { useTranslation } from "react-i18next"
import SelectPrimaryInput from "new-components/inputs/select-primary-input"
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import LinkOffIcon from '@mui/icons-material/LinkOff';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import PauseCircleOutlineIcon from '@mui/icons-material/PauseCircleOutline';
import IconDropdownButton from "new-components/buttons/icon-dropdown-button"

const FormVoucher = () => {

    const history = useHistory()
    const { t }: any = useTranslation()
    const location = useLocation()
    const branchIdCurrent = getBranch()
    const componentExportRef = useRef<HTMLDivElement>(null)

    const [isOpenSnack, setIsOpenSnack] = useState(false)
    const [typeSnack, setTypeSnack] = useState<any>("success")
    const [labelSnack, setLabelSnack] = useState('')
    const [loading, setLoading] = useState(false)
    const [voucherType, setVoucherType] = useState<any>()
    const [optionsType, setOptionsType] = useState<any>([])
    const [listType, setListType] = useState<any>()



    const [listProduct, setListProduct] = useState(false)
    const [dataVoucher, setDataVoucher] = useState<any>({
        voucherName: '',
        voucherNameEn: '',
        voucherTypeId: '',
        voucherPriceType: 'DISCOUNT',
        voucherPrice: '',
        voucherPriceUnit: 'BAHT',
        voucherPriceDFUnit: 'BAHT',
        voucherPriceDF: '',
        voucherPriceCF: '',
        voucherUsage: 'ALL',
        discountScope: 'TOTAL',
        minimum: 0,
        voucherPrefix: '',
        startDate: '',
        endDate: '',
        detail: '',
        voucherGroup: 'ALL',
        voucherGroups: [],
        voucherItems: [],
        qty: 0,
        connectPatient: '0',
        activationMode: 'AUTO'
    })
    const [errorMessage, setErrorMessage] = useState<any>({})
    const [subValue, setSubValue] = useState('ALL')
    const [isPrefixGV, setIsPrefixGV] = useState(false)
    const [isPatient, setIsPatient] = useState(false)
    const [dataVoucherList, setDataVoucherList] = useState<any>([])
    const [isDupicate, setIsDupicate] = useState(false)

    const [dataVoucherListExport, setDataVoucherListExport] = useState<any>([])

    const [page, setPage] = useState(1)
    const [pageLimit, setPageLimit] = useState(10)
    const [rowCount, setRowCount] = useState(0)
    const [sortBy, setSortBy] = useState('approvalId')
    const [sortType, setSortType] = useState('ASC')
    const [search, setSearch] = useState('')
    const [voucherId, setVoucherId] = useState(0)
    const [status, setStatus] = useState<any>(['WAITING', 'READY', 'USED', 'EXPIRED'])
    const [resultStatus, setResultStatus] = useState('')
    const [optionLotNumber, setOptionLotNumber] = useState([])
    const [lotNumber, setLotNumber] = useState<any>([])
    const [resultLotNumber, setResultLotNumber] = useState('')

    const [isChecks, setIsChecks] = useState([] as any)
    const [isCheckAll, setIsCheckAll] = useState('')

    const [countWaiting, setCountWaiting] = useState('')
    const [countReady, setCountReady] = useState('')
    const [countUsed, setCountUsed] = useState('')
    const [countExpired, setCountExpired] = useState('')
    const [optionSubGroup, setOptionSubGroup] = useState([])
    const [groupPatient, setGroupPatient] = useState('')
    const [subGroup, setSubGroup] = useState<any>([])
    const [totalCount, setTotalCount] = useState(0)

    const [isOpenPageModal, setIsOpenPageModal] = useState(false)
    const [voucherTotal, setVoucherTotal] = useState(0)
    const [dataStartDate, setDataStartDate] = useState('')
    const [dataEndDate, setDataEndDate] = useState('')
    const [isDelete, setIsDelete] = useState(false)
    const [name, setName] = useState('')
    const [voucherListId, setVoucherListId] = useState(0)
    const [rangeDate, setRangeDate] = useState<string[]>(['', ''])

    const [statusDelete, setStatusDelete] = useState('')

    const [copy, setCopy] = useState(0)

    const [alertActivationModal, setAlertActivationModal] = useState(false)
    const [activationAction, setActivationAction] = useState<'ACTIVATE' | 'DEACTIVATE' | null>(null)
    const [activationTarget, setActivationTarget] = useState<'BULK' | 'LOT' | 'SINGLE'>('BULK')
    const [activationLotNumber, setActivationLotNumber] = useState<number>(0)
    const [activationSingleId, setActivationSingleId] = useState<number>(0)
    const [activationSingleCode, setActivationSingleCode] = useState<string>('')
    const [activationLoading, setActivationLoading] = useState(false)

    // State สำหรับกำหนดเลข GV เอง (Popup เพิ่ม voucher list)
    const [isCustomCode, setIsCustomCode] = useState(false)
    const [customVoucherCodes, setCustomVoucherCodes] = useState('')
    const [customCodeMode, setCustomCodeMode] = useState<'manual' | 'running'>('running') // 'manual' = พิมพ์เอง, 'running' = running number
    const [runningPrefix, setRunningPrefix] = useState('VC' + new Date().getFullYear()) // เช่น VC2026
    const [runningStart, setRunningStart] = useState(1)
    const [runningEnd, setRunningEnd] = useState(100)
    const [runningDigits, setRunningDigits] = useState(6) // จำนวนหลัก เช่น 6 หลัก = 000001

    // State สำหรับกำหนดเลข GV เอง (Form หลักสร้าง voucher ใหม่)
    const [mainIsCustomCode, setMainIsCustomCode] = useState(false)
    const [mainCustomVoucherCodes, setMainCustomVoucherCodes] = useState('')
    const [mainCustomCodeMode, setMainCustomCodeMode] = useState<'manual' | 'running'>('running')
    const [mainRunningPrefix, setMainRunningPrefix] = useState('VC' + new Date().getFullYear())
    const [mainRunningStart, setMainRunningStart] = useState(1)
    const [mainRunningEnd, setMainRunningEnd] = useState(100)
    const [mainRunningDigits, setMainRunningDigits] = useState(6)

    const preparationVoucherType = async () => {
        const condition = {
            page: 1,
            pageLimit: 1000,
            SEARCH: '',
            sortBy: 'approvalId',
            sortType: 'ASC',
            STATUS: 'ACTIVE'
        }
        await VoucherApi.findAllType(condition).then((resp) => {
            if (resp.status === 200) {
                const result = _.map(resp.data, (item) => ({ name: item.voucherTypeName, value: item.voucherTypeId }))
                setVoucherType(result)
            }
        })
    }

    const preparationById = async (id: number, isCopy?: boolean) => {
        await VoucherApi.findVoucherById(id).then((resp) => {
            const scope = resp.data?.discountScope || (resp.data?.voucherUsage === 'ALL' ? 'TOTAL' : 'ITEM')
            if (scope === 'ITEM') {
                setSubValue('SUB')
            } else {
                setSubValue('ALL')
            }
            if (resp.data?.voucherPrefix) {
                setIsPrefixGV(true)
            }
            if (resp.data?.voucherItems?.length !== 0) {
                setListProduct(true)
                if (isCopy) {
                    preparationOptionType('OPERATIVE')
                    preparationOptionType('PRODUCT')
                    preparationOptionType('MEDICINE')
                    _.map(resp.data?.voucherItems, (item: any) => {
                        preparationListType(item)
                    })
                }

            }
            if (resp.data?.voucherGroups?.length !== 0) {
                setIsPatient(true)
                setGroupPatient(resp.data?.voucherGroups?.[0]?.groupType)
                preparationPatient(resp.data?.voucherGroups?.[0]?.groupType)
                setSubGroup(_.map(resp.data?.voucherGroups, (item) => item.groupTypeId))
            }
            const result = {
                ...resp.data,
                startDate: isCopy ? '' : moment(resp.data?.startDate).format('yyyy-MM-DD'),
                endDate: isCopy ? '' : moment(resp.data?.endDate).format('yyyy-MM-DD'),
                voucherName: isCopy ? `${resp.data?.voucherName}(copy)` : resp.data?.voucherName,
                voucherNameEn: isCopy ? resp.data?.voucherNameEn && `${resp.data?.voucherNameEn}(copy)` : resp.data?.voucherNameEn,
                branchId: isCopy && 0,
                voucherPrice: String(resp.data?.voucherPrice),
                connectPatient: resp.data?.connectPatient === '' ? '0' : resp.data?.connectPatient,
                voucherPrefix: isCopy ? '' : resp.data?.voucherPrefix,
                voucherPriceDFUnit: resp.data?.voucherPriceDFUnit || 'BAHT',
                discountScope: scope,
            }
            delete result.createdAt
            delete result.createdBy
            delete result.updatedAt
            delete result.updatedBy
            delete result.voucherType
            setDataStartDate(moment(resp.data?.startDate).format('yyyy-MM-DD'))
            setDataEndDate(moment(resp.data?.endDate).format('yyyy-MM-DD'))
            setDataVoucher(result)
        })
    }

    const preparationVoucherId = async (id: number, pageId?: number, checkExport?: boolean) => {
        setLoading(true)
        await VoucherApi.findVoucherListId(id, { page: pageId ? pageId : page, pageLimit: pageLimit, STATUS: resultStatus, SEARCH: search, lotNumber: resultLotNumber, startDate: rangeDate[0], endDate: rangeDate[1], EXPORT: checkExport ? '1' : '0' }).then((resp: any) => {
            if (resp.status === 200) {
                if (checkExport) {
                    setDataVoucherListExport(resp.data.rows)
                } else {
                    const statusReady = _.find(resp.data.statusCounts, (item) => item.status === 'READY')
                    const statusWaiting = _.find(resp.data.statusCounts, (item) => item.status === 'WAITING')
                    const statusUsed = _.find(resp.data.statusCounts, (item) => item.status === 'USED')
                    const statusExpired = _.find(resp.data.statusCounts, (item) => item.status === 'EXPIRED')
                    const lotNumbers: any = _.map(resp.data?.lotNumbers, (item) => ({ name: item.lotNumber.toString().padStart(4, '0'), id: item.lotNumber }))
                    const number: any = _.map(resp.data?.lotNumbers, (item) => item.lotNumber)
                    setRowCount(resp?.headers['x-total'] || 0)
                    setDataVoucherList(resp.data.rows)
                    setCountWaiting(statusWaiting?.count)
                    setCountReady(statusReady?.count)
                    setCountUsed(statusUsed?.count)
                    setCountExpired(statusExpired?.count)
                    setOptionLotNumber(lotNumbers)
                    setLotNumber(number)
                    setTotalCount(resp.data?.count)
                }
            }
        })
        setLoading(false)
    }

    const preparationPatient = async (data: string) => {
        if (data === 'RANK') {
            const condition: any = { page: 1, pageLimit: 50, sortType: 'ASC', sortBy: 'createdAt', status: 'ACTIVE' }
            await VoucherApi.findAllRankVoucher(condition).then((resPatientTypes) => {
                if (resPatientTypes.status === 200) {
                    const newData = resPatientTypes?.data.map((item: any) => {
                        return { name: item?.rankName, id: item?.rankId }
                    })
                    setOptionSubGroup(newData)
                }
            })
        } else {
            const condition: any = { page: 1, pageLimit: 50, sortType: 'ASC', sortBy: 'createdAt', status: 'ACTIVE' }
            await ComponentApi.findAllPatientType(condition).then((resPatientTypes) => {
                if (resPatientTypes.status === 200) {
                    const newData = resPatientTypes?.data.map((item: any) => {
                        return { name: item?.patientTypeName, id: item?.patientTypeId }
                    })
                    setOptionSubGroup(newData)
                }
            })
        }
    }

    const preparationOptionType = async (itemType: string) => {
        if (itemType === 'OPERATIVE') {
            const res = await OperativeTypeApi.findAll({ pageLimit: 30, status: 'ACTIVE' })
            if (res.status === 200) {
                const newData = res.data.map((value: any) => {
                    return { itemTypeName: value.operativeTypeName, itemTypeId: value.operativeTypeId }
                })
                setOptionsType(newData)
            }
        } else {
            const condition: any = { group: itemType, pageLimit: 10, status: 'ACTIVE' }
            const res = await ProductTypesApi.findAll(condition)
            if (res.status === 200) {
                const newData = res.data.map((value: any) => {
                    return { itemTypeName: value.productTypeName, itemTypeId: value.productTypeId }
                })
                setOptionsType(newData)
            }
        }
    }

    const preparationListType = async (value: any) => {
        if (value.itemType === 'OPERATIVE') {
            const res = await OperativeApi.findAll({ pageLimit: 30, status: 'ACTIVE', operativeTypeId: value.itemTypeId })
            if (res.status === 200) {
                const newData = res.data.map((value: any) => {
                    return { itemName: value.operativeName, itemId: value.operativeId, itemPrice: value.salePrice }
                })
                setListType(newData)
            }
        } else {
            const condition: any = { group: value.itemType, status: 'ACTIVE', page: 1, pageLimit: 10, itemTypeId: value.itemTypeId }
            const res = await ProductsApi.findAll(condition)
            if (res.status === 200) {
                const newData = res.data.map((value: any) => {
                    return { itemName: value.productName, itemId: value.productId, itemPrice: value?.salePrice || 0 }
                })
                setListType(newData)
            }
        }
    }

    useEffect(() => {
        preparationVoucherType()
        if (location.state) {
            const dataEdit: any = location?.state
            setVoucherId(dataEdit?.voucherId)
            if (dataEdit?.copy) {
                setVoucherId(0)
                preparationById(dataEdit.voucherId, true)
            } else {
                setVoucherId(dataEdit?.voucherId)
                preparationById(dataEdit.voucherId)
            }


        }
    }, [])

    useEffect(() => {
        if (location.state) {
            const dataEdit: any = location?.state
            preparationVoucherId(dataEdit.voucherId)
        }
        return () => {
            setSearch('')
            setStatus([])
            setLotNumber([])
            setRangeDate(['', ''])
        }
    }, [page, pageLimit])

    useEffect(() => {
        if (location.state) {
            const dataEdit: any = location?.state
            preparationVoucherId(dataEdit.voucherId, page, true)
        }
    }, [])

    const onCheckErrorSubmit = () => {
        // แยก custom codes จาก string เป็น array (สำหรับ form หลัก)
        const mainManualCodesArray = mainIsCustomCode && mainCustomCodeMode === 'manual' && mainCustomVoucherCodes
            ? mainCustomVoucherCodes.split(/[\n,]/).map(code => code.trim()).filter(code => code !== '')
            : []
        const mainManualCodesUpper = mainManualCodesArray.map((c: string) => c.toUpperCase())
        const mainHasDuplicateInList = mainManualCodesUpper.length > 0 && mainManualCodesUpper.length !== new Set(mainManualCodesUpper).size

        // Running number validation (สำหรับ form หลัก)
        const mainRunningCount = mainRunningEnd - mainRunningStart + 1

        // วันที่เริ่มต้องไม่เกินวันที่สิ้นสุด
        const hasStart = !!dataVoucher?.startDate
        const hasEnd = !!dataVoucher?.endDate
        let dateRangeError = ''
        if (hasStart && hasEnd && dataVoucher.startDate && dataVoucher.endDate) {
            const start = new Date(dataVoucher.startDate).getTime()
            const end = new Date(dataVoucher.endDate).getTime()
            if (start > end) dateRangeError = t('VOUCHER.ERROR.DATE_RANGE')
        }

        const hasVoucherItems = dataVoucher?.voucherItems?.length > 0

        let qtyError = ''
        if (!mainIsCustomCode) {
            if (dataVoucher.qty === '' || dataVoucher.qty === undefined || dataVoucher.qty === null) qtyError = t('VOUCHER.ERROR.QTY')
            else if (Number(dataVoucher.qty) > 2000) qtyError = t('VOUCHER.ERROR.QTY_LENGTH')
            else if (Number(dataVoucher.qty) < 1) qtyError = t('VOUCHER.ERROR.QTY_MIN_1')
        }
        let minimumError = ''
        if (dataVoucher.minimum === '' || dataVoucher.minimum === undefined || dataVoucher.minimum === null) minimumError = t('VOUCHER.ERROR.MINIMUM_EMPTY')
        else if (Number(dataVoucher.minimum) < 0) minimumError = t('VOUCHER.ERROR.MINIMUM_NEGATIVE')

        const newError: any = {
            "VOUCHERNAME": !dataVoucher?.voucherName?.trim?.() ? t('VOUCHER.ERROR.VOUCHERNAME') : '',
            "VOUCHERTYPEID": !dataVoucher.voucherTypeId ? t('VOUCHER.ERROR.VOUCHERTYPEID') : '',
            "DISCOUNT": dataVoucher.voucherPriceType === 'DISCOUNT' && (dataVoucher.voucherPrice === '' || dataVoucher.voucherPrice === undefined || dataVoucher.voucherPrice === null) ? t('VOUCHER.ERROR.DISCOUNT') : '',
            "SALEPRICE": dataVoucher.voucherPriceType === 'SALEPRICE' && (dataVoucher.voucherPrice === '' || dataVoucher.voucherPrice === undefined || dataVoucher.voucherPrice === null) ? t('VOUCHER.ERROR.SALEPRICE') : '',
            "MINIMUM": minimumError,
            "QTY": qtyError,
            "STARTDATE": !dataVoucher.startDate ? t('VOUCHER.ERROR.STARTDATE') : '',
            "ENDDATE": !dataVoucher.endDate ? t('VOUCHER.ERROR.ENDDATE') : '',
            "DATE_RANGE": dateRangeError,
            "VOUCHERPREFIX": isPrefixGV && !dataVoucher.voucherPrefix?.trim?.() ? t('VOUCHER.ERROR.VOUCHERPREFIX') : '',
            "GROUPTYPE": isPatient && !dataVoucher.voucherGroups?.[0]?.groupType ? t('VOUCHER.ERROR.GROUPTYPE') : '',
            "GROUPTYPEID": isPatient && !dataVoucher.voucherGroups?.[0]?.groupTypeId ? t('VOUCHER.ERROR.GROUPTYPEID') : '',
            "VOUCHER_ITEMS_EMPTY": listProduct && !hasVoucherItems ? t('VOUCHER.ERROR.VOUCHER_ITEMS_MIN') : '',
            "ITEMTYPE": listProduct && hasVoucherItems && dataVoucher.voucherItems.some((item: any) => !item?.itemType) ? t('VOUCHER.ERROR.ITEMTYPE') : '',
            "ITEMID": listProduct && hasVoucherItems && dataVoucher.voucherItems.some((item: any) => !item?.itemId) ? t('VOUCHER.ERROR.ITEMID') : '',
            "QTYGV": listProduct && hasVoucherItems && dataVoucher.voucherItems.some((item: any) => item?.qty === undefined || item?.qty === '' || item?.qty === null) ? t('VOUCHER.ERROR.QTYGV') : '',
            "MAIN_CUSTOMCODES": mainIsCustomCode && mainCustomCodeMode === 'manual' && mainManualCodesArray.length === 0 ? t('VOUCHER.ERROR.CUSTOMCODES_MIN') : '',
            "MAIN_CUSTOMCODES_DUPLICATE": mainHasDuplicateInList ? t('VOUCHER.MESSAGE.DUPLICATE_IN_LIST') : '',
            "MAIN_CUSTOMCODES_MAX": mainIsCustomCode && mainCustomCodeMode === 'manual' && mainManualCodesArray.length > 2000 ? t('VOUCHER.ERROR.CUSTOMCODES_MAX') : '',
            "MAIN_RUNNING_PREFIX": mainIsCustomCode && mainCustomCodeMode === 'running' && !mainRunningPrefix?.trim?.() ? t('VOUCHER.ERROR.RUNNING_PREFIX_REQUIRED') : '',
            "MAIN_RUNNING_START": mainIsCustomCode && mainCustomCodeMode === 'running' && (mainRunningStart == null || mainRunningStart < 1) ? t('VOUCHER.ERROR.RUNNING_START_REQUIRED') : '',
            "MAIN_RUNNING_END": mainIsCustomCode && mainCustomCodeMode === 'running' && (mainRunningEnd == null || mainRunningEnd < mainRunningStart) ? t('VOUCHER.ERROR.RUNNING_END_GTE') : '',
            "MAIN_RUNNING_MAX": mainIsCustomCode && mainCustomCodeMode === 'running' && mainRunningCount > 2000 ? t('VOUCHER.ERROR.CUSTOMCODES_MAX') : '',
            "DF_CF_SUM": (() => {
                if (dataVoucher.voucherUsage !== 'OPERATIVE' || (dataVoucher.voucherPriceDFUnit || 'BAHT') !== 'PERCENT') return ''
                const df = Number(dataVoucher.voucherPriceDF) || 0
                const cf = Number(dataVoucher.voucherPriceCF) || 0
                if (dataVoucher.voucherPriceDF === '' || dataVoucher.voucherPriceDF === undefined) return t('VOUCHER.ERROR.DF_CF_REQUIRED')
                if (df + cf !== 100) return t('VOUCHER.ERROR.DF_CF_PERCENT_MUST_100')
                return ''
            })(),
            "DF_CF_BAHT": dataVoucher.voucherUsage === 'OPERATIVE' && (dataVoucher.voucherPriceDFUnit || 'BAHT') === 'BAHT' && (dataVoucher.voucherPriceDF === '' || dataVoucher.voucherPriceDF === undefined) ? t('VOUCHER.ERROR.DF_CF_BAHT_REQUIRED') : '',
        }
        return newError
    }
    const onCreateGV = async () => {
        setLoading(true)

        const newError = onCheckErrorSubmit()
        if (Object.values(newError).some(value => value !== "")) {
            console.log('newError',newError)
            setErrorMessage(newError)
            setLoading(false)
            return
        }

        // สร้าง custom codes array ถ้าเลือกกำหนดเอง
        let codesArray: string[] = []
        if (mainIsCustomCode) {
            if (mainCustomCodeMode === 'running') {
                codesArray = generateMainRunningCodes()
            } else {
                codesArray = mainCustomVoucherCodes
                    .split(/[\n,]/)
                    .map(code => code.trim().toUpperCase())
                    .filter(code => code !== '')
            }
            // เช็คซ้ำกับรายการที่เคยสร้างในระบบก่อนบันทึก
            if (codesArray.length > 0) {
                try {
                    const checkResp = await VoucherApi.checkVoucherCodesExisting(codesArray)
                    const existingCodes = checkResp?.data?.existingCodes || []
                    if (existingCodes.length > 0) {
                        setIsOpenSnack(true)
                        setTypeSnack('error')
                        setLabelSnack(`${t('VOUCHER.MESSAGE.CODE_ALREADY_EXISTS')}: ${existingCodes.join(', ')}`)
                        setLoading(false)
                        return
                    }
                } catch (_) {
                    // ถ้า API error ให้ไปลอง submit ได้ เซิร์ฟเวอร์จะดักซ้ำอีกครั้ง
                }
            }
        }

        const newData: any = {
            ...dataVoucher,
            voucherPrice: Number(dataVoucher?.voucherPrice),
            qty: mainIsCustomCode ? codesArray.length : dataVoucher.qty,
            isCustomCode: mainIsCustomCode,
            customVoucherCodes: mainIsCustomCode ? codesArray : undefined,
            discountScope: dataVoucher.discountScope || 'TOTAL'
        }
        if (newData.voucherUsage === 'OPERATIVE' && (newData.voucherPriceDFUnit || 'BAHT') === 'PERCENT') {
            const dfNum = Number(newData.voucherPriceDF) || 0
            newData.voucherPriceCF = String(100 - dfNum)
        }
        if (newData.voucherUsage === 'OPERATIVEDF') {
            newData.voucherPriceDF = '100'
        }
        if (newData.voucherUsage === 'OPERATIVECF') {
            newData.voucherPriceCF = '100'
        }

        const cloneNewData = _.cloneDeep(newData.voucherItems)

        newData.voucherItems = newData.voucherItems.map((item: any) => {
            return {
                itemId: item.itemId,
                itemType: item.itemType,
                qty: item.qty,
            }
        })
        

        setLoading(true)
        await VoucherApi.createVoucher(newData).then((resp) => {
            setVoucherId(resp.data)
            setIsOpenSnack(true)
            setTypeSnack('success')
            setLabelSnack(t('VOUCHER.MESSAGE.SAVE_SUCCESS'))
            setTimeout(() => {
                history.push(routeName.voucher)
            }, 1500);
        }).catch((err) => {
            // setDataVoucher({ ...dataVoucher, voucherItems: cloneNewData })
            if (err?.response?.data?.message === 'IS_DUPLICATE_VOUCHER_PREFIX') {
                setIsDupicate(true)
            } else if (err?.response?.data?.message === 'IS_DUPLICATE_NAME') {
                setErrorMessage((prev: any) => ({
                    ...prev,
                    'VOUCHERNAME': t('VOUCHER.MESSAGE.DUPICATE_NAME')
                }))
            } else if (err?.response?.data?.message === 'IS_DUPLICATE_NAME_EN') {
                setErrorMessage((prev: any) => ({
                    ...prev,
                    'VOUCHERNAMEEN': t('VOUCHER.MESSAGE.DUPICATE_NAMEEN')
                }))
            } else if (err?.response?.data?.message?.includes('VOUCHER_CODE_ALREADY_EXISTS')) {
                setIsOpenSnack(true)
                setTypeSnack('error')
                const codes = err.response?.data?.message?.replace?.('VOUCHER_CODE_ALREADY_EXISTS: ', '') || ''
                setLabelSnack(codes ? `${t('VOUCHER.MESSAGE.CODE_ALREADY_EXISTS')}: ${codes}` : t('VOUCHER.MESSAGE.CODE_ALREADY_EXISTS'))
            } else if (err?.response?.data?.message === 'DUPLICATE_CUSTOM_VOUCHER_CODES' || err?.response?.data?.message?.startsWith?.('DUPLICATE_CUSTOM_VOUCHER_CODES:')) {
                setIsOpenSnack(true)
                setTypeSnack('error')
                const msg = err?.response?.data?.message || ''
                const codes = msg.replace('DUPLICATE_CUSTOM_VOUCHER_CODES: ', '').trim()
                setLabelSnack(codes ? `${t('VOUCHER.MESSAGE.DUPLICATE_IN_LIST')}: ${codes}` : t('VOUCHER.MESSAGE.DUPLICATE_IN_LIST'))
            } else if (err?.response?.data?.message === 'CUSTOM_VOUCHER_CODES_EMPTY') {
                setIsOpenSnack(true)
                setTypeSnack('error')
                setLabelSnack(t('VOUCHER.ERROR.CUSTOMCODES_MIN'))
            }

            setLoading(false)
        })
    }

    const selectableVoucherList = _.filter(dataVoucherList, (item: any) => item.status !== 'USED' && !String(item?.ownerName || '').trim())

    const handleOnCheckAll = () => {
        const hasSome = _.some(selectableVoucherList, (i: any) => _.some(isChecks, (j: number) => Number(i.voucherListId) === Number(j)))
        const hasAll = selectableVoucherList.length > 0 && _.every(selectableVoucherList, (i: any) => _.some(isChecks, (j: number) => Number(i.voucherListId) === Number(j)))
        if (!_.isEmpty(isChecks) && !hasAll && hasSome) setIsCheckAll('indeterminate')
        else if (!_.isEmpty(isChecks) && hasAll) setIsCheckAll('checked')
        else setIsCheckAll('')
    }

    useEffect(() => {
        handleOnCheckAll()
    }, [isChecks, dataVoucherList])

    useEffect(() => {
        if (_.isEmpty(isChecks)) return
        const selectableIdSet = new Set(_.map(selectableVoucherList, 'voucherListId').map(Number))
        setIsChecks((prev: any) => _.filter(prev, (id: number) => selectableIdSet.has(Number(id))))
    }, [dataVoucherList])

    const onCheckAll = (event: any) => {
        const { checked } = event
        const id = _.map(selectableVoucherList, 'voucherListId')
        if (checked) {
            if (isCheckAll === 'indeterminate') {
                setIsChecks([])
            } else {
                setIsChecks(Array.from(new Set([...isChecks, ...id])))
            }
        } else {
            setIsChecks(_.filter(isChecks, (i) => !_.includes(id, i)))
        }
    }

    const onCheck = (event: any) => {
        const { checked, value } = event
        const currentRow = _.find(dataVoucherList, (item: any) => Number(item.voucherListId) === Number(value))
        if (currentRow && String(currentRow?.ownerName || '').trim()) return
        if (checked) {
            setIsChecks([...isChecks, Number(value)])
        } else {
            setIsChecks(
                _.filter(isChecks, (i: number) => {
                    return i !== Number(value)
                })
            )
        }
    }

    const selectedVoucherRows = _.filter(
        _.map(isChecks, (check) => _.find(dataVoucherList, (item) => Number(item.voucherListId) === Number(check))),
        Boolean
    )
    const hasNonWaitingSelected = _.some(selectedVoucherRows, (item: any) => item?.status !== 'WAITING')

    const deleteTableList = async (id?: number) => {

        const handleError = (msg: string) => {
            const msgError = ['THIS_VOUCHER_IS_BEING_USED']
            if (msgError.includes(msg)) {
                setLabelSnack(t(`VOUCHER.ERROR.${msgError}`))
            } else {
                setLabelSnack(t('VOUCHER.ERROR.ERROR'))
            }
        }

        if (statusDelete === 'DELETED') {
            if (id) {
                const selectedRow = _.find(dataVoucherList, (item: any) => Number(item.voucherListId) === Number(id))
                if (selectedRow && selectedRow.status !== 'WAITING') {
                    setIsDelete(false)
                    setIsOpenSnack(true)
                    setTypeSnack('error')
                    setLabelSnack(t('VOUCHER.MESSAGE.ERROR'))
                    return
                }
            } else if (hasNonWaitingSelected) {
                setIsDelete(false)
                setIsOpenSnack(true)
                setTypeSnack('error')
                setLabelSnack(t('VOUCHER.MESSAGE.ERROR'))
                return
            }
        }

        if (id) {
            await VoucherApi.deleteVoucherList([id], statusDelete).then(() => {
                setIsDelete(false)
                setIsOpenSnack(true)
                setTypeSnack('success')
                setLabelSnack(t('VOUCHER.MESSAGE.SAVE_SUCCESS'))
                preparationVoucherId(voucherId)
                preparationVoucherId(voucherId, page, true)
            }).catch((error) => {
                setIsDelete(false)
                setIsOpenSnack(true)
                setTypeSnack('error')
                const msg = error?.response?.data?.message
                handleError(msg)
            })
        } else {
            await VoucherApi.deleteVoucherList(isChecks, statusDelete).then(() => {
                setIsDelete(false)
                setIsOpenSnack(true)
                setTypeSnack('success')
                setLabelSnack(t('VOUCHER.MESSAGE.SAVE_SUCCESS'))
                preparationVoucherId(voucherId)
                preparationVoucherId(voucherId, page, true)
            }).catch((error) => {
                setIsDelete(false)
                setIsOpenSnack(true)
                setTypeSnack('error')
                setLabelSnack(t('VOUCHER.MESSAGE.ERROR'))
                const msg = error?.response?.data?.message
                handleError(msg)
            })
        }
        setName('')
        setIsCheckAll('')
        setIsChecks([])
    }

    const headCells = [
        {
            id: 'voucherSelect',
            disablePadding: false,
            label: 'CHECKBOX',
            indeterminate: isCheckAll === 'indeterminate' ? true : false,
            checked: isCheckAll === 'checked' && true,
            disableDropdown: true,
            values: [],
            onCheckAll: (event: any) => onCheckAll(event.target),
            width: '70px'
        },
        { id: 'no', disablePadding: false, label: '#', width: '60px' },
        { id: 'id', disablePadding: false, label: t('VOUCHER.FORM.TABLE_VOUCHER_LIST.ID') },
        { id: 'status', disablePadding: false, label: t('VOUCHER.FORM.TABLE_VOUCHER_LIST.STATUS'), align: 'center', width: '100px' },
        { id: 'litNumber', disablePadding: false, label: t('VOUCHER.FORM.TABLE_VOUCHER_LIST.LOTNUMBER'), align: 'center', width: '120px' },
        { id: 'startDate', disablePadding: false, label: t('VOUCHER.FORM.TABLE_VOUCHER_LIST.START_DATE'), align: 'center', width: '150px' },
        { id: 'endDate', disablePadding: false, label: t('VOUCHER.FORM.TABLE_VOUCHER_LIST.END_DATE'), align: 'center', width: '150px' },
        { id: 'Owner', disablePadding: false, label: t('VOUCHER.FORM.TABLE_VOUCHER_LIST.OWNER'), align: 'center', width: '200px' },
        { id: 'UpdatedAt', disablePadding: false, label: t('VOUCHER.FORM.TABLE_VOUCHER_LIST.UPDATED_BY'), align: 'center', width: '200px' },
        { id: 'action', disablePadding: false, label: 'Action', align: 'center', width: '80px' }
    ]

    const headCellsGV = [
        { id: 'no', disablePadding: false, label: t('VOUCHER.FORM.TABLE.NO'), width: '100px' },
        { id: 'voucherUsage', disablePadding: false, label: t('VOUCHER.FORM.TABLE.CATEGORY') },
        { id: 'type', disablePadding: false, label: t('VOUCHER.FORM.TABLE.TYPE') },
        { id: 'list', disablePadding: false, label: t('VOUCHER.FORM.TABLE.LIST') },
        { id: 'amount', disablePadding: false, label: t('VOUCHER.FORM.TABLE.AMOUNT') },
    ]

    const renderDataGV = (objData: any, index: number) => {
        const objRenderData = {
            key: voucherListId,
            id: voucherListId,
            obj: objData,
            columns: [
                { option: 'TEXT', align: 'center', label: index + 1 },
                { option: 'TEXT', align: 'left', label: objData?.itemType === 'OPERATIVE' ? t('VOUCHER.FORM.TABLE.ITEM_TYPE_OPERATIVE') : objData?.itemType === 'MEDICINE' ? t('VOUCHER.FORM.TABLE.ITEM_TYPE_MEDICINE') : t('VOUCHER.FORM.TABLE.ITEM_TYPE_PRODUCT') },
                { option: 'TEXT', align: 'left', label: objData?.itemTypeName || '-' },
                { option: 'TEXT', align: 'left', label: objData?.itemName || '-' },
                { option: 'TEXT', align: 'left', label: objData?.qty || '-' },
            ]
        }

        return (
            <TableRowCommon {...objRenderData} onCheck={(e) => onCheck(e.target)} />
        )
    }

    const statusType = (status: string) => {
        switch (status) {
            case 'READY':
                return t('VOUCHER.FORM.STATUS_READY')
            case 'WAITING':
                return t('VOUCHER.FORM.STATUS_WAITING')
            case 'USED':
                return t('VOUCHER.FORM.STATUS_USED')
            case 'EXPIRED':
                return t('VOUCHER.FORM.STATUS_EXPIRED')
            default:
                return ''
        }
    }

    const handleCopy = (voucherCode: any, index: number) => {
        setCopy(index);
        navigator.clipboard.writeText(voucherCode);
        setTimeout(() => {
            setCopy(0);
        }, 2000);
    };

    const isFormManualMode = dataVoucher?.activationMode === 'MANUAL'

    const handleActivation = (target: 'BULK' | 'LOT' | 'SINGLE', action: 'ACTIVATE' | 'DEACTIVATE', lotNum?: number, singleId?: number, singleCode?: string) => {
        setActivationTarget(target)
        setActivationAction(action)
        setActivationLotNumber(lotNum || 0)
        setActivationSingleId(singleId || 0)
        setActivationSingleCode(singleCode || '')
        setAlertActivationModal(true)
    }

    const onConfirmActivation = async () => {
        if (!activationAction || !voucherId) return
        setActivationLoading(true)
        try {
            let resp: any
            if (activationTarget === 'LOT') {
                resp = await VoucherApi.updateLotStatus(voucherId, activationLotNumber, activationAction)
            } else if (activationTarget === 'SINGLE') {
                resp = await VoucherApi.updateSingleVoucherStatus(voucherId, [activationSingleId], activationAction)
            } else {
                resp = await VoucherApi.updateSingleVoucherStatus(voucherId, isChecks.map(Number), activationAction)
            }
            if (resp.status === 200) {
                setIsOpenSnack(true)
                setTypeSnack('success')
                setLabelSnack(activationAction === 'ACTIVATE' ? t('VOUCHER.LOT.ACTIVATE_SUCCESS') : t('VOUCHER.LOT.DEACTIVATE_SUCCESS'))
                preparationVoucherId(voucherId)
                preparationVoucherId(voucherId, page, true)
            }
        } catch {
            setIsOpenSnack(true)
            setTypeSnack('error')
            setLabelSnack(t('VOUCHER.MESSAGE.ERROR'))
        }
        setAlertActivationModal(false)
        setActivationAction(null)
        setActivationLoading(false)
    }

    const getActivationModalTitle = () => {
        if (!activationAction) return ''
        if (activationTarget === 'LOT') return activationAction === 'ACTIVATE' ? t('VOUCHER.LOT.CONFIRM_ACTIVATE_TITLE') : t('VOUCHER.LOT.CONFIRM_DEACTIVATE_TITLE')
        if (activationTarget === 'SINGLE') return activationAction === 'ACTIVATE' ? t('VOUCHER.SINGLE.CONFIRM_ACTIVATE_TITLE') : t('VOUCHER.SINGLE.CONFIRM_DEACTIVATE_TITLE')
        return activationAction === 'ACTIVATE' ? t('VOUCHER.BULK.CONFIRM_ACTIVATE_TITLE') : t('VOUCHER.BULK.CONFIRM_DEACTIVATE_TITLE')
    }

    const getActivationModalMessage = () => {
        if (!activationAction) return ''
        if (activationTarget === 'LOT') return activationAction === 'ACTIVATE' ? t('VOUCHER.LOT.CONFIRM_ACTIVATE_MSG', { lot: String(activationLotNumber).padStart(4, '0') }) : t('VOUCHER.LOT.CONFIRM_DEACTIVATE_MSG', { lot: String(activationLotNumber).padStart(4, '0') })
        if (activationTarget === 'SINGLE') return activationAction === 'ACTIVATE' ? t('VOUCHER.SINGLE.CONFIRM_ACTIVATE_MSG', { code: activationSingleCode }) : t('VOUCHER.SINGLE.CONFIRM_DEACTIVATE_MSG', { code: activationSingleCode })
        return activationAction === 'ACTIVATE' ? t('VOUCHER.BULK.CONFIRM_ACTIVATE_MSG', { count: isChecks.length }) : t('VOUCHER.BULK.CONFIRM_DEACTIVATE_MSG', { count: isChecks.length })
    }

    const renderData = (objData: any, index: number, isExport?: boolean) => {
        index = page * pageLimit - pageLimit + index + 1
        const { voucherCode, status, lotNumber, startDate, endDate, ownerName, usedDate, updatedBy, updatedAt, voucherListId } = objData
        const rowCheck = _.some(isChecks, (i: number) => Number(i) === Number(voucherListId))
        const objRenderData = {
            key: voucherListId,
            id: voucherListId,
            obj: objData,
            rowSelect: rowCheck,
            columns: [
                { option: 'CHECKBOX', align: 'center', label: voucherListId, disabled: status === 'USED' || !!String(ownerName || '').trim() },
                { option: 'TEXT', align: 'center', label: index },
                {
                    option: 'COMPONENT', align: 'left', component:
                        <Box
                            onClick={() => status === "READY" && navigator.clipboard.writeText(voucherCode)}
                            sx={{ cursor: 'pointer', position: 'relative' }}
                        >
                            <Box display="flex" flexDirection="row" alignItems="center" gap="8px" position="relative">
                                <Typography>{voucherCode}</Typography>
                                <Box>
                                    {copy === index &&
                                        <Box position="absolute" padding="10px" bgcolor="#5A5A5A" color="#FFFFFF" borderRadius="2px" top="-40px" fontSize="14px" fontWeight={400}>{t('VOUCHER.FORM.COPIED')}</Box>
                                    }
                                    {status === 'READY' && <ContentCopyIcon onClick={() => handleCopy(voucherCode, index)} sx={{ color: '#808080', height: '22px', width: '20px' }} />}
                                </Box>
                            </Box>
                        </Box>
                },
                { option: 'COMPONENT', align: 'center', component: <Box fontSize="16px" fontWeight={400} color={status === 'READY' ? '#1CB99A' : status === 'WAITING' ? '#EDBA07' : status === 'USED' ? '#5A5A5A' : '#B00020'}>{statusType(status)}</Box> },
                { option: 'TEXT', align: 'center', label: lotNumber.toString().padStart(4, '0') || '' },
                { option: 'TEXT', align: 'center', label: dateToView(startDate) || '' },
                { option: 'TEXT', align: 'center', label: dateToView(endDate) || '' },
                { option: 'UPDATE_BY', align: 'center', label: { updatedBy: ownerName || '-', updatedAt: usedDate !== null ? usedDate : '-' } },
                { option: 'UPDATE_BY', align: 'center', label: { updatedBy: updatedBy || '-', updatedAt: updatedAt ?? '10/12/2564 08.59' } },
                {
                    option: 'COMPONENT', align: 'center', component:
                        <IconDropdownButton options={[
                            ...(isFormManualMode ? [
                                {
                                    label: t('VOUCHER.SINGLE.ACTIVATE'), onClick: () => handleActivation('SINGLE', 'ACTIVATE', 0, voucherListId, voucherCode),
                                    icon: <PlayCircleOutlineIcon sx={{ color: '#808080' }} />, disabled: status !== 'WAITING'
                                },
                                {
                                    label: t('VOUCHER.SINGLE.DEACTIVATE'), onClick: () => handleActivation('SINGLE', 'DEACTIVATE', 0, voucherListId, voucherCode),
                                    icon: <PauseCircleOutlineIcon sx={{ color: '#808080' }} />, disabled: status !== 'READY' || !!ownerName
                                },
                            ] : []),
                            {
                                label: t('VOUCHER.FORM.ACTION_UNLINK'), onClick: () => {
                                    setVoucherListId(voucherListId)
                                    setName(voucherCode)
                                    setStatusDelete('UNLINK')
                                    setIsDelete(true)
                                }, icon: <LinkOffIcon sx={{ color: '#808080' }} />, disabled: !ownerName || status === 'USED'
                            },
                            {
                                label: t('VOUCHER.FORM.ACTION_DELETE'), onClick: () => {
                                    setVoucherListId(voucherListId)
                                    setName(voucherCode)
                                    setStatusDelete('DELETED')
                                    setIsDelete(true)
                                }, icon: <DeleteOutlineOutlinedIcon sx={{ color: '#808080' }} />, disabled: status !== 'WAITING'
                            }
                        ]} />
                }
            ]
        }


        return (
            <TableRowCommon {...objRenderData} onCheck={(e) => onCheck(e.target)} />
        )




    }

    const renderDataVoucher = (objData: any, index: number, isExport?: boolean) => {
        if (isExport) {
            index = index + 1
        } else {
            index = page * pageLimit - pageLimit + index + 1
        }

        const { voucherCode, status, lotNumber, startDate, endDate, ownerName, usedDate, updatedBy, updatedAt, voucherListId } = objData
        const rowCheck = _.some(isChecks, (i: number) => Number(i) === Number(voucherListId))
        const statusTypeExport = (status: string) => {
            switch (status) {
                case 'READY':
                    return t('VOUCHER.FORM.STATUS_READY')
                case 'WAITING':
                    return t('VOUCHER.FORM.STATUS_WAITING')
                case 'USED':
                    return t('VOUCHER.FORM.STATUS_USED')
                case 'EXPIRED':
                    return t('VOUCHER.FORM.STATUS_EXPIRED')
                default:
                    return ''
            }
        }

        const objRenderData = {
            key: voucherListId,
            id: voucherListId,
            obj: objData,
            rowSelect: rowCheck,
            columns: [
                { option: 'TEXT', align: 'center', label: index },
                { option: 'TEXT', align: 'left', label: voucherCode || '' },
                { option: 'TEXT', align: 'center', label: statusTypeExport(status) },
                { option: 'TEXT', align: 'center', label: lotNumber.toString().padStart(4, 0) || '' },
                { option: 'TEXT', align: 'center', label: dateToView(startDate) || '' },
                { option: 'TEXT', align: 'center', label: dateToView(endDate) || '' },
                { option: 'UPDATE_BY', align: 'center', label: { updatedBy: ownerName || '-', updatedAt: usedDate !== null ? usedDate : '-' } },
                // { option: 'UPDATE_BY', align: 'center', label: { updatedBy: updatedBy || '-', updatedAt: updatedAt ?? '10/12/2564 08.59' } },
            ]
        }

        if (isExport) {
            return <TableRowExport {...objRenderData} />
        }
    }

    const handleLotNumber = (number: any) => {
        const dataNumber: any = number[number.length - 1]
        const data = dataNumber?.id + 1
        const result = data.toString().padStart(4, '0');
        return result
    }

    // Function สร้าง running number codes (Popup)
    const generateRunningCodes = () => {
        const codes: string[] = []
        for (let i = runningStart; i <= runningEnd; i++) {
            const paddedNumber = i.toString().padStart(runningDigits, '0')
            codes.push(`${runningPrefix}${paddedNumber}`)
        }
        return codes
    }

    // Function สร้าง running number codes (Form หลัก)
    const generateMainRunningCodes = () => {
        const codes: string[] = []
        for (let i = mainRunningStart; i <= mainRunningEnd; i++) {
            const paddedNumber = i.toString().padStart(mainRunningDigits, '0')
            codes.push(`${mainRunningPrefix}${paddedNumber}`)
        }
        return codes
    }

    const parseManualVoucherCodes = (rawCodes = '') => {
        return rawCodes
            .split(/[\s,]+/)
            .map(code => code.trim())
            .filter(code => code !== '')
    }

    const onCheckErrorSubmitModal = () => {
        // แยก custom codes จาก string เป็น array
        const manualCodesArray = isCustomCode && customCodeMode === 'manual' && customVoucherCodes
            ? parseManualVoucherCodes(customVoucherCodes)
            : []

        // Running number validation
        const runningCount = runningEnd - runningStart + 1

        const newError: any = {
            "VOUCHERTOTAL": !isCustomCode ? (!voucherTotal ? t('VOUCHER.FORM.MODAL.ERROR_TITLE') : (voucherTotal > 2000 ? t('VOUCHER.FORM.MODAL.ERROR_MAX_LENGTH') : '')) : '',
            "DATASTARTDATE": !dataStartDate ? t('VOUCHER.FORM.MODAL.ERROR_STARTDATE') : '',
            "DATAENDDATE": !dataEndDate ? t('VOUCHER.FORM.MODAL.ERROR_ENDDATE') : '',
            // Manual mode validation
            "CUSTOMCODES": isCustomCode && customCodeMode === 'manual' && manualCodesArray.length === 0 ? t('VOUCHER.ERROR.CUSTOMCODES_MIN') : '',
            "CUSTOMCODES_MAX": isCustomCode && customCodeMode === 'manual' && manualCodesArray.length > 2000 ? t('VOUCHER.ERROR.CUSTOMCODES_MAX') : '',
            // Running number mode validation
            "RUNNING_PREFIX": isCustomCode && customCodeMode === 'running' && !runningPrefix ? t('VOUCHER.ERROR.RUNNING_PREFIX_REQUIRED') : '',
            "RUNNING_START": isCustomCode && customCodeMode === 'running' && (!runningStart || runningStart < 1) ? t('VOUCHER.ERROR.RUNNING_START_REQUIRED') : '',
            "RUNNING_END": isCustomCode && customCodeMode === 'running' && (!runningEnd || runningEnd < runningStart) ? t('VOUCHER.ERROR.RUNNING_END_GTE') : '',
            "RUNNING_MAX": isCustomCode && customCodeMode === 'running' && runningCount > 2000 ? t('VOUCHER.ERROR.CUSTOMCODES_MAX') : '',
        }
        return newError
    }

    const onCreateVoucherModal = async () => {

        const newError = onCheckErrorSubmitModal()
        if (Object.values(newError).some(value => value !== "")) {
            setErrorMessage(newError)
            return
        }

        let codesArray: string[] = []

        if (isCustomCode) {
            if (customCodeMode === 'running') {
                // Generate running number codes
                codesArray = generateRunningCodes()
            } else {
                // Manual mode - แยก custom codes จาก string เป็น array
                codesArray = parseManualVoucherCodes(customVoucherCodes)
                    .map(code => code.trim().toUpperCase())
                    .filter(code => code !== '')
                // ดักรหัสซ้ำในรายการก่อนส่ง API
                const uniqueUpper = Array.from(new Set(codesArray))
                if (codesArray.length > 0 && uniqueUpper.length !== codesArray.length) {
                    const duplicates = codesArray.filter((code: string, i: number) => codesArray.indexOf(code) !== i)
                    const duplicateList = Array.from(new Set(duplicates))
                    setIsOpenSnack(true)
                    setTypeSnack('error')
                    setLabelSnack(duplicateList.length ? `${t('VOUCHER.MESSAGE.DUPLICATE_IN_LIST')}: ${duplicateList.join(', ')}` : t('VOUCHER.MESSAGE.DUPLICATE_IN_LIST'))
                    setLoading(false)
                    return
                }
            }
            // เช็คซ้ำกับรายการที่เคยสร้างในระบบก่อนบันทึก
            if (codesArray.length > 0) {
                try {
                    const checkResp = await VoucherApi.checkVoucherCodesExisting(codesArray)
                    const existingCodes = checkResp?.data?.existingCodes || []
                    if (existingCodes.length > 0) {
                        setIsOpenSnack(true)
                        setTypeSnack('error')
                        setLabelSnack(`${t('VOUCHER.MESSAGE.CODE_ALREADY_EXISTS')}: ${existingCodes.join(', ')}`)
                        setLoading(false)
                        return
                    }
                } catch (_) {
                    // ถ้า API error ให้ไปลอง submit ได้ เซิร์ฟเวอร์จะดักซ้ำอีกครั้ง
                }
            }
        }

        const body: any = {
            qty: isCustomCode ? codesArray.length : voucherTotal,
            startDate: dataStartDate,
            endDate: dataEndDate,
            branchId: branchIdCurrent,
            isCustomCode: isCustomCode,
            customVoucherCodes: isCustomCode ? codesArray : undefined
        }
        await VoucherApi.createVoucherModal(voucherId, body).then((resp) => {
            setIsOpenSnack(true)
            setTypeSnack('success')
            setLabelSnack(t('VOUCHER.MESSAGE.SAVE_SUCCESS'))
            setIsOpenPageModal(false)
            preparationVoucherId(voucherId)
            preparationVoucherId(voucherId, page, true)
            // Reset state
            setIsCustomCode(false)
            setCustomVoucherCodes('')
            setCustomCodeMode('running')
            setRunningStart(1)
            setRunningEnd(100)
        }).catch((err) => {
            setIsOpenSnack(true)
            setTypeSnack('error')
            if (err?.response?.data?.message?.includes('VOUCHER_CODE_ALREADY_EXISTS')) {
                const codes = err.response?.data?.message?.replace?.('VOUCHER_CODE_ALREADY_EXISTS: ', '') || ''
                setLabelSnack(codes ? `${t('VOUCHER.MESSAGE.CODE_ALREADY_EXISTS')}: ${codes}` : t('VOUCHER.MESSAGE.CODE_ALREADY_EXISTS'))
            } else if (err?.response?.data?.message === 'DUPLICATE_CUSTOM_VOUCHER_CODES' || err?.response?.data?.message?.startsWith?.('DUPLICATE_CUSTOM_VOUCHER_CODES:')) {
                const msg = err?.response?.data?.message || ''
                const codes = msg.replace('DUPLICATE_CUSTOM_VOUCHER_CODES: ', '').trim()
                setLabelSnack(codes ? `${t('VOUCHER.MESSAGE.DUPLICATE_IN_LIST')}: ${codes}` : t('VOUCHER.MESSAGE.DUPLICATE_IN_LIST'))
            } else if (err?.response?.data?.message === 'CUSTOM_VOUCHER_CODES_EMPTY') {
                setLabelSnack(t('VOUCHER.ERROR.CUSTOMCODES_MIN'))
            } else if (err?.response?.status === 413 || err?.message === 'Network Error') {
                setLabelSnack(t('VOUCHER.ERROR.CUSTOMCODES_MAX'))
            } else {
                setLabelSnack(t('VOUCHER.MESSAGE.ERROR'))
            }
            setLoading(false)
            setIsOpenPageModal(false)
        })
        setVoucherTotal(0)
    }

    const handleTotalPrice = () => {
        return dataVoucher?.voucherItems.reduce((acc: number, item: any) => {
            if (item.itemPrice && item.qty) {
                return acc + (item.itemPrice * item.qty);
            }
            return acc
        }, 0)?.toLocaleString()

    }

    return (
        <Box paddingX="24px" paddingY="32px">
            <AlertModal
                isOpen={isDupicate}
                title={t('VOUCHER.MESSAGE.PREFIX_DUPICATE_TITLE')}
                message={t('VOUCHER.MESSAGE.PREFIX_DUPICATE_MESSAGE')}
                type="warning"
                onSubmit={{ onClick: () => null }}
                onCancel={{ onClick: () => setIsDupicate(false), title: t('VOUCHER.MESSAGE.PREFIX_DUPICATE_CANCEL') }}
                onCloseSubmit
                handleClose={() => setIsDupicate(false)}
            />
            <SnackbarComponent
                onOpen={isOpenSnack}
                onClose={() => setIsOpenSnack(false)}
                label={labelSnack}
                type={typeSnack}
                transform={`translateX(calc(100vw - 100% - 32px)) translateY(calc(-100vh + 100% + ${window.innerHeight - 50}px))`}
                autoHideTime={3000}
            />
            <Loading show={loading} />
            <Box display="flex" justifyContent="space-between" alignItems="center">
                <Box display="flex" flexDirection="column" gap="16px">
                    <Box display="flex" gap='16px'>
                        <Typography fontSize="14px" fontWeight={400} sx={{ cursor: 'pointer' }} onClick={() => history.push(`${routeName.voucher}`)}>{t('VOUCHER.FORM.MANAGE_TITLE')}</Typography>
                        <Typography fontSize="14px" fontWeight={400}>{'>'}</Typography>
                        <Typography fontSize="14px" fontWeight={400}>{voucherId !== 0 ? t('VOUCHER.FORM.TITLE_UPDATE') : t('VOUCHER.FORM.TITLE_CREATE')}</Typography>
                    </Box>
                    <Typography fontSize="24px" fontWeight={500}>{voucherId !== 0 ? t('VOUCHER.FORM.TITLE_UPDATE') : t('VOUCHER.FORM.TITLE_CREATE')}</Typography>
                </Box>
                <Box display={voucherId !== 0 ? "none" : "flex"} flexDirection="row" alignItems="center" gap="16px">
                    <MainButton
                        title={t('VOUCHER.FORM.BUTTON_CANCEL')}
                        type="secondary"
                        variant="outlined"
                        onClick={() => history.push(routeName.voucher)}
                        style={{ width: '120px' }}
                    />
                    <MainButton
                        title={t('VOUCHER.FORM.BUTTON_SAVE')}
                        type="primary"
                        variant="contained"
                        onClick={() => {
                            onCreateGV()
                        }}
                        style={{ width: '120px' }}
                    />
                </Box>
            </Box>
            <Box marginTop="24px" boxShadow="0px 0px 12px 0px #CCCCCC;" borderRadius="8px" paddingX="32px" paddingY="24px" >
                <Grid container spacing="16px">
                    <Grid item xs={12} md={4}>
                        <TextInput
                            required
                            label={t('VOUCHER.FORM.VOUCHER_NAME')}
                            value={dataVoucher.voucherName}
                            onChange={(e) => {
                                setDataVoucher({ ...dataVoucher, voucherName: e.target.value })
                                setErrorMessage({ ...errorMessage, 'VOUCHERNAME': '' })
                            }}
                            fullWidth
                            helperText={errorMessage.VOUCHERNAME}
                            inputProps={{ value: dataVoucher.voucherName }}
                            disabled={voucherId !== 0}
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextInput
                            label={t('VOUCHER.FORM.VOUCHER_NAMEEN')}
                            value={dataVoucher.voucherNameEn}
                            onChange={(e) => setDataVoucher({ ...dataVoucher, voucherNameEn: e.target.value })}
                            fullWidth
                            inputProps={{ value: dataVoucher.voucherNameEn }}
                            disabled={voucherId !== 0}
                            helperText={errorMessage.VOUCHERNAMEEN}
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <SelectInput
                            required
                            label={t('VOUCHER.FORM.VOUCHER_TYPE')}
                            onChange={(e) => {
                                setDataVoucher({ ...dataVoucher, voucherTypeId: e.target.value })
                                setErrorMessage({ ...errorMessage, 'VOUCHERTYPEID': '' })
                            }}
                            options={voucherType}
                            value={dataVoucher.voucherTypeId}
                            helperText={errorMessage.VOUCHERTYPEID}
                            disabled={voucherId !== 0}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <CheckboxButton checked={listProduct} onChange={(e) => {
                            if (!e.target.checked) {
                                setSubValue("ALL")
                                setDataVoucher({ ...dataVoucher, voucherUsage: dataVoucher.voucherUsage === 'ALL' ? 'ALL' : dataVoucher.voucherUsage, discountScope: 'TOTAL', voucherItems: [], voucherPriceType: 'DISCOUNT' })
                            } else {
                                setSubValue("SUB")
                                setDataVoucher({ ...dataVoucher, voucherUsage: "OPERATIVEDF", discountScope: 'ITEM', voucherItems: [...dataVoucher.voucherItems, {}] })
                            }
                            setListProduct(e.target.checked)
                        }} label={t('VOUCHER.FORM.BIND_OP_MED_PD')} disabled={voucherId !== 0} />
                        {listProduct &&
                            <Box>
                                <Typography marginTop="32px" marginBottom="16px" fontSize="14px" fontWeight={500}>{dataVoucher.voucherItems?.length > 1 ? t('VOUCHER.FORM.BIND_OP_MED_PD_DETAIL_ALL') : t('VOUCHER.FORM.BIND_OP_MED_PD_DETAIL')}</Typography>
                                {errorMessage.VOUCHER_ITEMS_EMPTY && <Typography color="error" fontSize="12px" sx={{ mb: 1 }}>{errorMessage.VOUCHER_ITEMS_EMPTY}</Typography>}
                                <Box marginTop="16px" overflow="scroll">
                                    {voucherId === 0 ?
                                        <Table sx={{ border: `1px solid #E5E5E5`, color: 'white', minWidth: 800, borderRadius: '8px' }}>
                                            <TableHead sx={{ backgroundColor: '#2F4269', color: 'white', }}>
                                                <TableRow>
                                                    <TableCell align="center" sx={{ color: 'white', fontSize: "18px", fontWeight: '600px', width: '100px' }}>{t('VOUCHER.FORM.TABLE.NO')}</TableCell>
                                                    <TableCell sx={{ color: 'white', fontSize: "18px", fontWeight: '600px', minWidth: '50px', maxWidth: '400px' }}>{t('VOUCHER.FORM.TABLE.CATEGORY')}</TableCell>
                                                    <TableCell sx={{ color: 'white', fontSize: "18px", fontWeight: '600px', minWidth: '50px', maxWidth: '400px' }}>{t('VOUCHER.FORM.TABLE.TYPE')}</TableCell>
                                                    <TableCell sx={{ color: 'white', fontSize: "18px", fontWeight: '600px', minWidth: '50px', maxWidth: '400px' }}>{t('VOUCHER.FORM.TABLE.LIST')}</TableCell>
                                                    <TableCell sx={{ color: 'white', fontSize: "18px", fontWeight: '600px', width: '200px' }}>{t('VOUCHER.FORM.TABLE.AMOUNT')}</TableCell>
                                                    <TableCell align="center" sx={{ color: 'white', fontSize: "18px", fontWeight: '600px', width: '100px' }}>{'Action'}</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell colSpan={12}>
                                                        <Box onClick={() => {
                                                            const checked = dataVoucher?.voucherItems[dataVoucher?.voucherItems?.length - 1]?.qty
                                                            if (checked || dataVoucher?.voucherItems.length === 0) {
                                                                setDataVoucher({ ...dataVoucher, voucherItems: [...dataVoucher.voucherItems, {}] })
                                                            }
                                                        }} sx={{ cursor: dataVoucher?.voucherItems[dataVoucher?.voucherItems?.length - 1]?.qty || dataVoucher?.voucherItems.length === 0 ? 'pointer' : 'default', color: dataVoucher?.voucherItems[dataVoucher?.voucherItems?.length - 1]?.qty || dataVoucher?.voucherItems.length === 0 ? '#1CB99A' : '#C5C5C5' }}>{t('VOUCHER.FORM.ADD_ROW')}</Box>
                                                    </TableCell>
                                                </TableRow>
                                                {dataVoucher.voucherItems.map((data: any, index: number) => (
                                                    <TableRow key={`row-${index}`} sx={{ height: '100px' }}>
                                                        <TableCell style={{ verticalAlign: 'top' }} align="center" ><Typography marginTop="10px">{index + 1}</Typography></TableCell>
                                                        <TableCell style={{ verticalAlign: 'top' }}>
                                                            <SelectInput
                                                                required
                                                                label={t('VOUCHER.FORM.TABLE.CATEGORY')}
                                                                width={{ xs: '200px', md: '200px', lg: '99%', xl: '%' }}
                                                                onChange={(e) => {
                                                                    const updateItem = [...dataVoucher.voucherItems]
                                                                    updateItem[index] = { ...updateItem[index], itemType: e.target.value, itemTypeId: null, itemTypeName: null, itemId: null, itemName: null }
                                                                    const hasOp = updateItem.some((it: any) => it.itemType === 'OPERATIVE')
                                                                    const hasNonOp = updateItem.some((it: any) => it.itemType && it.itemType !== 'OPERATIVE')
                                                                    let nextUsage = dataVoucher.voucherUsage
                                                                    if (!hasOp && hasNonOp) {
                                                                        nextUsage = 'PRODUCT'
                                                                    } else if (hasOp && !hasNonOp && nextUsage === 'PRODUCT') {
                                                                        nextUsage = 'OPERATIVEDF'
                                                                    } else if (updateItem.length === 1) {
                                                                        nextUsage = updateItem[0]?.itemType !== 'OPERATIVE' ? 'PRODUCT' : 'OPERATIVEDF'
                                                                    }
                                                                    setDataVoucher({ ...dataVoucher, voucherItems: updateItem, voucherUsage: nextUsage })
                                                                }}
                                                                value={data.itemType}
                                                                options={[
                                                                    { name: t('VOUCHER.FORM.TABLE.ITEM_TYPE_OPERATIVE'), value: 'OPERATIVE' },
                                                                    { name: t('VOUCHER.FORM.TABLE.ITEM_TYPE_MEDICINE'), value: 'MEDICINE' },
                                                                    { name: t('VOUCHER.FORM.TABLE.ITEM_TYPE_PRODUCT'), value: 'PRODUCT' },
                                                                ]}
                                                                helperText={(errorMessage.ITEMTYPE && !data.itemType) ? errorMessage.ITEMTYPE || '' : ''}
                                                            />
                                                        </TableCell>
                                                        <TableCell style={{ verticalAlign: 'top' }}>
                                                            <AutocompleteSelect
                                                                height={40}
                                                                labelId="1"
                                                                inputLabel={t('VOUCHER.FORM.TABLE.TYPE')}
                                                                noOptionsText={t('VOUCHER.FORM.NO_OPTIONS')}
                                                                getOptionLabel={(option) => option?.itemTypeName || ''}
                                                                options={optionsType || []}
                                                                renderOption={(props, option) => {
                                                                    return (
                                                                        <Box {...props} >
                                                                            {option?.itemTypeName}
                                                                        </Box>
                                                                    )
                                                                }}
                                                                onInputChange={(_event: any, _value: string, reason?: string) => {
                                                                    if (reason !== 'input') return
                                                                    if (!data?.itemType) return
                                                                    preparationOptionType(data.itemType)
                                                                }}
                                                                onOpen={() => preparationOptionType(data.itemType)}
                                                                onchange={(_e, value) => {
                                                                    const updateItem = [...dataVoucher.voucherItems]
                                                                    updateItem[index] = { ...updateItem[index], itemTypeId: value.itemTypeId, itemTypeName: value.itemTypeName }
                                                                    setDataVoucher({ ...dataVoucher, voucherItems: updateItem })
                                                                }}
                                                                value={data}
                                                                disabled={!data.itemType}
                                                                disableClearable
                                                                required
                                                                errMessage={(errorMessage.ITEMID && !data.itemTypeName) ? t('VOUCHER.ERROR.ITEMTYPE') : ''}
                                                            />

                                                        </TableCell>
                                                        <TableCell style={{ verticalAlign: 'top' }}>
                                                            <AutocompleteSelect
                                                                height={40}
                                                                labelId="1"
                                                                inputLabel={t('VOUCHER.FORM.TABLE.LIST')}
                                                                noOptionsText={t('VOUCHER.FORM.NO_OPTIONS')}
                                                                getOptionLabel={(option) => option?.itemName || ''}
                                                                options={listType || []}
                                                                renderOption={(props, option) => {
                                                                    return (
                                                                        <Box {...props} >
                                                                            {option?.itemName}
                                                                        </Box>
                                                                    )
                                                                }}
                                                                onInputChange={(_event: any, _value: string, reason?: string) => {
                                                                    if (reason !== 'input') return
                                                                    if (!data?.itemTypeId) return
                                                                    preparationListType(data)
                                                                }}
                                                                onOpen={() => preparationListType(data)}
                                                                onchange={(e, value) => {
                                                                    const updateItem = [...dataVoucher.voucherItems]
                                                                    updateItem[index] = { ...updateItem[index], ...value }
                                                                    setDataVoucher({ ...dataVoucher, voucherItems: updateItem })
                                                                }}
                                                                value={data}
                                                                disabled={!data.itemTypeId}
                                                                disableClearable
                                                                required
                                                                errMessage={(errorMessage.ITEMID && !data.itemId) ? errorMessage.ITEMID : ''}
                                                            />

                                                        </TableCell>
                                                        <TableCell style={{ verticalAlign: 'top' }}>
                                                            <TextInput
                                                                required
                                                                label={t('VOUCHER.FORM.TABLE.AMOUNT')}
                                                                numberOnly
                                                                onChange={(e) => {
                                                                    const updateItem = [...dataVoucher.voucherItems]
                                                                    updateItem[index] = { ...updateItem[index], qty: e.target.value }
                                                                    setDataVoucher({ ...dataVoucher, voucherItems: updateItem })
                                                                }}
                                                                fullWidth
                                                                value={data.qty}
                                                                disabled={!data?.itemId}
                                                                helperText={(errorMessage.QTYGV && !data.qty) ? errorMessage.QTYGV : ''}
                                                            />
                                                        </TableCell>
                                                        <TableCell style={{ verticalAlign: 'top' }} align="center">
                                                            <IconButton
                                                                className={'btn-delete'}
                                                                disableFocusRipple
                                                                disableRipple
                                                                disableTouchRipple
                                                                aria-label="delete"
                                                                onClick={() => {
                                                                    const remaining = dataVoucher?.voucherItems?.filter((_item: any, num: number) => num !== index)
                                                                    if (remaining.length === 0) {
                                                                        setListProduct(false)
                                                                        setSubValue('ALL')
                                                                        setDataVoucher({ ...dataVoucher, voucherItems: remaining, discountScope: 'TOTAL', voucherUsage: dataVoucher.voucherUsage === 'ALL' ? 'ALL' : dataVoucher.voucherUsage })
                                                                    } else {
                                                                        const hasOp = remaining.some((it: any) => it.itemType === 'OPERATIVE')
                                                                        const hasNonOp = remaining.some((it: any) => it.itemType && it.itemType !== 'OPERATIVE')
                                                                        let nextUsage = dataVoucher.voucherUsage
                                                                        if (!hasOp && hasNonOp) nextUsage = 'PRODUCT'
                                                                        else if (hasOp && !hasNonOp && nextUsage === 'PRODUCT') nextUsage = 'OPERATIVEDF'
                                                                        setDataVoucher({ ...dataVoucher, voucherItems: remaining, voucherUsage: nextUsage })
                                                                    }
                                                                }}
                                                            >
                                                                <img src={icons.btnTrash} alt="trash" style={{ width: 24 }} />
                                                            </IconButton>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                        : <TableCustom
                                            page={1}
                                            pageLimit={99}
                                            sortType={''}
                                            sortBy={''}
                                            onSort={() => console.log()}
                                            setPageLimit={() => console.log()}
                                            setPage={() => console.log()}
                                            rowCount={1}
                                            hidePagination
                                            headCells={headCellsGV}
                                            rowsData={dataVoucher.voucherItems.map((item: any, index: number) => {
                                                return renderDataGV(item, index)
                                            })}

                                        />
                                    }
                                </Box>
                                <Box width="100%" bgcolor="#F7F8F8" height="54px" paddingX="32px" marginY="16px" display="flex" flexDirection="row" gap='100px' justifyContent="end" alignItems="center">
                                    <Typography fontSize="18px" fontWeight={400}>{t('VOUCHER.FORM.TOTALPRICE')}</Typography>
                                    <Typography fontSize="18px" fontWeight={400}>{handleTotalPrice()} {t('VOUCHER.FORM.BAHT')}</Typography>
                                </Box>
                            </Box>
                        }


                    </Grid>
                    <Grid item xs={4}>
                        <Grid container>
                            <Grid item xs={6}>
                                <Typography>{t('VOUCHER.FORM.PRICE_TYPE_COST')}</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <RadioButton
                                    name="radio-buttons-group"
                                    onChange={(e) => {
                                        setDataVoucher({ ...dataVoucher, voucherPriceType: e.target.value, voucherPrice: '' })
                                    }}
                                    sx={{ gap: '16px' }}
                                    // defaultValue={dataVoucher.voucherPriceType}
                                    options={[
                                        { label: t('VOUCHER.FORM.PRICE_TYPE_DISCOUNT'), value: 'DISCOUNT', disabled: voucherId !== 0 },
                                        { label: t('VOUCHER.FORM.PRICE_TYPE_SALEPRICE'), value: 'SALEPRICE', disabled: !listProduct || voucherId !== 0 }
                                    ]}
                                    value={dataVoucher.voucherPriceType}
                                    disabled={voucherId !== 0}

                                />

                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={4}>
                        <Box display="flex" flexDirection="row" gap="8px">
                            <TextInput required label={t('VOUCHER.FORM.COST')} numberOnly onChange={(e) => {
                                const value = e.target.value
                                const newValue = (dataVoucher?.voucherPriceUnit === "PERCENT" && Number(value) > 100) ? 100 : value
                                const next: any = { ...dataVoucher, voucherPrice: newValue }
                                if (dataVoucher.voucherUsage === 'OPERATIVE' && (dataVoucher.voucherPriceDFUnit || 'BAHT') === 'BAHT') {
                                    next.voucherPriceCF = String(Math.max(0, (Number(newValue) || 0) - (Number(dataVoucher.voucherPriceDF) || 0)))
                                }
                                setDataVoucher(next)
                                setErrorMessage({ ...errorMessage, 'DISCOUNT': '' })
                            }} fullWidth disabled={dataVoucher.voucherPriceType !== 'DISCOUNT' || voucherId !== 0} helperText={errorMessage.DISCOUNT} inputProps={{ value: dataVoucher.voucherPriceType === 'DISCOUNT' && dataVoucher.voucherPrice || '' }} />
                            <SelectInput
                                required
                                label={t('VOUCHER.FORM.COST_UNIT')}
                                value={dataVoucher.voucherPriceUnit}
                                onChange={(e) => {
                                    const unit = e.target.value
                                    const nextData: any = {
                                        ...dataVoucher,
                                        voucherPriceUnit: unit,
                                        voucherPrice: unit === 'PERCENT' ? dataVoucher.voucherPrice : (dataVoucher.voucherPrice || 0)
                                    }
                                    // If main discount unit is %, DF/CF split must use % only.
                                    if (unit === 'PERCENT' && dataVoucher.voucherUsage === 'OPERATIVE') {
                                        nextData.voucherPriceDFUnit = 'PERCENT'
                                        nextData.voucherPriceDF = '50'
                                        nextData.voucherPriceCF = '50'
                                    }
                                    setDataVoucher(nextData)
                                }}
                                options={[
                                    { name: t('VOUCHER.FORM.BAHT'), value: 'BAHT' },
                                    { name: '%', value: 'PERCENT' }
                                ]}
                                disabled={dataVoucher.voucherPriceType !== 'DISCOUNT' || voucherId !== 0}
                            />
                        </Box>
                        <Grid container spacing="8px" alignItems="center" marginTop="8px">
                            <Grid item xs={6}>
                                <Box display="flex" flexDirection="row" gap="8px">
                                    <TextInput required label={t('VOUCHER.FORM.AMOUNT')} numberOnly onChange={(e) => {
                                        const v = e.target.value
                                        const next: any = { ...dataVoucher, voucherPrice: v }
                                        if (dataVoucher.voucherUsage === 'OPERATIVE' && (dataVoucher.voucherPriceDFUnit || 'BAHT') === 'BAHT') {
                                            next.voucherPriceCF = String(Math.max(0, (Number(v) || 0) - (Number(dataVoucher.voucherPriceDF) || 0)))
                                        }
                                        setDataVoucher(next)
                                    }} fullWidth disabled={dataVoucher.voucherPriceType !== 'SALEPRICE' || voucherId !== 0} helperText={errorMessage.SALEPRICE} inputProps={{ value: dataVoucher.voucherPriceType === 'SALEPRICE' && dataVoucher.voucherPrice || '' }} />
                                </Box>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography alignItems="ceneter" fontSize="16px" fontWeight={400}>{t('VOUCHER.FORM.BAHT')}</Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={4}></Grid>
                    <Grid item xs={4}>
                        <Grid container>
                            <Grid item xs={6}>
                                <Typography fontSize="16px" fontWeight={400}>{t('VOUCHER.FORM.USAGE')}</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <RadioButton
                                    name="voucherUsage"
                                    onChange={(e) => {
                                        if (e.target.value === 'ALL') {
                                            setSubValue(e.target.value)
                                            const currentUsage = dataVoucher.voucherUsage
                                            const keepUsage = ['OPERATIVEDF', 'OPERATIVECF', 'OPERATIVE', 'PRODUCT'].includes(currentUsage) ? currentUsage : 'ALL'
                                            setDataVoucher({ ...dataVoucher, discountScope: 'TOTAL', voucherUsage: keepUsage })
                                        } else {
                                            setSubValue('SUB')
                                            setDataVoucher({ ...dataVoucher, discountScope: 'ITEM', voucherUsage: 'OPERATIVEDF' })
                                        }
                                    }}

                                    sx={{ gap: '16px' }}
                                    value={subValue}
                                    defaultValue={subValue}
                                    options={[
                                        { label: t('VOUCHER.FORM.USAGE_ALL'), value: 'ALL', disabled: subValue === 'SUB' && dataVoucher?.voucherItems.length <= 1 || voucherId !== 0, tooltip: t('VOUCHER.FORM.USAGE_ALL_HOVER') },
                                        { label: t('VOUCHER.FORM.USAGE_LIST'), value: 'SUB', disabled: subValue === 'ALL' || voucherId !== 0, tooltip: t('VOUCHER.FORM.USAGE_LIST_HOVER') }
                                    ]}
                                    disabled={voucherId !== 0}
                                    toolTip
                                />
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={8}></Grid>
                    <Grid item xs={12}>
                        <Grid container>
                            <Grid item xs={2}>
                                <Typography fontSize="16px" fontWeight={400}>{t('VOUCHER.FORM.DISCOUNT_SCOPE')}</Typography>
                            </Grid>
                            <Grid item xs={10}>
                                {(() => {
                                    const isItemScope = dataVoucher.discountScope === 'ITEM'
                                    const items = dataVoucher.voucherItems || []
                                    const filledItems = items.filter((it: any) => it.itemType)
                                    const hasOp = filledItems.some((it: any) => it.itemType === 'OPERATIVE')
                                    const hasNonOp = filledItems.some((it: any) => it.itemType !== 'OPERATIVE')
                                    const showOpOptions = !isItemScope || filledItems.length === 0 || hasOp
                                    const showPdOption = !isItemScope || filledItems.length === 0 || hasNonOp
                                    return (
                                <Box display="flex" flexDirection="column" gap="8px">
                                    {/* ทุกรายการ (เฉพาะเมื่อเป็นลดจากราคารวม) */}
                                    {subValue === 'ALL' && (
                                        <Box display="flex" alignItems="center" width="100%">
                                            <RadioButton
                                                name="subVoucherUsage"
                                                onChange={(e) => setDataVoucher({ ...dataVoucher, voucherUsage: e.target.value, voucherPriceDF: '', voucherPriceCF: '' })}
                                                sx={{ gap: '16px' }}
                                                value={dataVoucher.voucherUsage === 'ALL' ? 'ALL' : ''}
                                                options={[
                                                    { label: 'ทุกรายการ', value: 'ALL', disabled: voucherId !== 0 },
                                                ]}
                                                disabled={voucherId !== 0}
                                            />
                                        </Box>
                                    )}
                                    {/* หัตถการเฉพาะ DF */}
                                    {showOpOptions && (
                                    <Box display="flex" alignItems="center" width="100%">
                                        <RadioButton
                                            name="subVoucherUsage"
                                            onChange={(e) => setDataVoucher({ ...dataVoucher, voucherUsage: e.target.value, voucherPriceDF: '100', voucherPriceCF: '' })}
                                            sx={{ gap: '16px' }}
                                            value={dataVoucher.voucherUsage === 'OPERATIVEDF' ? 'OPERATIVEDF' : ''}
                                            options={[
                                                { label: t('VOUCHER.FORM.USAGE_LIST_DF'), value: 'OPERATIVEDF', disabled: voucherId !== 0 },
                                            ]}
                                            disabled={voucherId !== 0}
                                        />
                                    </Box>
                                    )}

                                    {/* หัตถการเฉพาะ CF */}
                                    {showOpOptions && (
                                    <Box display="flex" alignItems="center" width="100%">
                                        <RadioButton
                                            name="subVoucherUsage"
                                            onChange={(e) => setDataVoucher({ ...dataVoucher, voucherUsage: e.target.value, voucherPriceDF: '', voucherPriceCF: '100' })}
                                            sx={{ gap: '16px' }}
                                            value={dataVoucher.voucherUsage === 'OPERATIVECF' ? 'OPERATIVECF' : ''}
                                            options={[
                                                { label: t('VOUCHER.FORM.USAGE_LIST_CF'), value: 'OPERATIVECF', disabled: voucherId !== 0 },
                                            ]}
                                            disabled={voucherId !== 0}
                                        />
                                    </Box>
                                    )}

                                    {/* หัตถการ DF และ CF */}
                                    {showOpOptions && (
                                    <Box display="flex" flexDirection="column" gap="8px">
                                        <Box display="flex" alignItems="center" width="100%">
                                            <RadioButton
                                                name="subVoucherUsage"
                                                onChange={(e) => setDataVoucher({
                                                    ...dataVoucher,
                                                    voucherUsage: e.target.value,
                                                    voucherPriceDFUnit: dataVoucher.voucherPriceUnit === 'PERCENT' ? 'PERCENT' : (dataVoucher.voucherPriceDFUnit || 'BAHT'),
                                                    voucherPriceDF: (dataVoucher.voucherPriceUnit === 'PERCENT' || (dataVoucher.voucherPriceDFUnit || 'BAHT') === 'PERCENT') ? '50' : '',
                                                    voucherPriceCF: (dataVoucher.voucherPriceUnit === 'PERCENT' || (dataVoucher.voucherPriceDFUnit || 'BAHT') === 'PERCENT') ? '50' : ''
                                                })}
                                                sx={{ gap: '16px' }}
                                                value={dataVoucher.voucherUsage === 'OPERATIVE' ? 'OPERATIVE' : ''}
                                                options={[
                                                    { label: t('VOUCHER.FORM.USAGE_LIST_DF_CF'), value: 'OPERATIVE', disabled: voucherId !== 0 },
                                                ]}
                                                disabled={voucherId !== 0}
                                            />
                                        </Box>
                                        {dataVoucher.voucherUsage === 'OPERATIVE' && (
                                            <Box display="flex" flexDirection="column" gap="8px" sx={{ pl: '32px' }}>
                                                <Box display="flex" alignItems="center" gap="8px">
                                                    <Typography fontSize="14px" fontWeight={500}>{t('VOUCHER.FORM.DF_CF_UNIT')}</Typography>
                                                    <SelectInput
                                                        value={dataVoucher.voucherPriceUnit === 'PERCENT' ? 'PERCENT' : (dataVoucher.voucherPriceDFUnit || 'BAHT')}
                                                        onChange={(e) => {
                                                            if (dataVoucher.voucherPriceUnit === 'PERCENT') {
                                                                setDataVoucher({
                                                                    ...dataVoucher,
                                                                    voucherPriceDFUnit: 'PERCENT',
                                                                    voucherPriceDF: '50',
                                                                    voucherPriceCF: '50'
                                                                })
                                                                setErrorMessage({ ...errorMessage, DF_CF_SUM: '', DF_CF_BAHT: '' })
                                                                return
                                                            }
                                                            const unit = e.target.value
                                                            const isPercent = unit === 'PERCENT'
                                                            setDataVoucher({
                                                                ...dataVoucher,
                                                                voucherPriceDFUnit: unit,
                                                                voucherPriceDF: isPercent ? '50' : '',
                                                                voucherPriceCF: isPercent ? '50' : ''
                                                            })
                                                            setErrorMessage({ ...errorMessage, DF_CF_SUM: '', DF_CF_BAHT: '' })
                                                        }}
                                                        options={[
                                                            ...(dataVoucher.voucherPriceUnit === 'PERCENT'
                                                                ? [{ name: '%', value: 'PERCENT' }]
                                                                : [
                                                                    { name: t('VOUCHER.FORM.BAHT'), value: 'BAHT' },
                                                                    { name: '%', value: 'PERCENT' }
                                                                ])
                                                        ]}
                                                        disabled={voucherId !== 0 || dataVoucher.voucherPriceUnit === 'PERCENT'}
                                                        width={{ xs: '100px', md: '100px' }}
                                                    />
                                                </Box>
                                                {(dataVoucher.voucherPriceDFUnit || 'BAHT') === 'PERCENT' ? (
                                                    <>
                                                        <Box display="flex" alignItems="center" gap="16px">
                                                            <Box display="flex" alignItems="center" gap="8px">
                                                                <Box width="80px">
                                                                    <TextInput
                                                                        label="DF %"
                                                                        value={dataVoucher.voucherUsage === 'OPERATIVE' ? (dataVoucher.voucherPriceDF || '') : ''}
                                                                        onChange={(e) => {
                                                                            const value = e.target.value?.replace(/[^0-9]/g, '')
                                                                            const capped = value === '' ? '' : String(Math.min(Number(value), 100))
                                                                            const dfNum = capped === '' ? 0 : Number(capped)
                                                                            const cfNum = 100 - dfNum
                                                                            setDataVoucher({ ...dataVoucher, voucherPriceDF: capped, voucherPriceCF: String(cfNum) })
                                                                            setErrorMessage({ ...errorMessage, DF_CF_SUM: '' })
                                                                        }}
                                                                        disabled={voucherId !== 0 || dataVoucher.voucherUsage !== 'OPERATIVE'}
                                                                    />
                                                                </Box>
                                                                <Typography>%</Typography>
                                                            </Box>
                                                            <Box display="flex" alignItems="center" gap="8px">
                                                                <Box width="80px">
                                                                    <TextInput
                                                                        label="CF %"
                                                                        value={dataVoucher.voucherUsage === 'OPERATIVE' ? (100 - (Number(dataVoucher.voucherPriceDF) || 0)).toString() : ''}
                                                                        onChange={() => { /* CF is readonly */ }}
                                                                        disabled
                                                                    />
                                                                </Box>
                                                                <Typography>%</Typography>
                                                            </Box>
                                                        </Box>
                                                        <Box sx={{ mt: 0.5 }}>
                                                            <Typography fontSize="12px" color="text.secondary">{t('VOUCHER.FORM.DF_CF_PERCENT_SUM')}</Typography>
                                                            {errorMessage.DF_CF_SUM && (
                                                                <Typography fontSize="12px" color="error" sx={{ mt: 0.5 }}>{errorMessage.DF_CF_SUM}</Typography>
                                                            )}
                                                        </Box>
                                                    </>
                                                ) : (
                                                    <>
                                                        <Box display="flex" alignItems="center" gap="16px">
                                                            <Box display="flex" alignItems="center" gap="8px">
                                                                <Box width="100px">
                                                                    <TextInput
                                                                        label={t('VOUCHER.FORM.DF_BAHT')}
                                                                        numberOnly
                                                                        value={dataVoucher.voucherUsage === 'OPERATIVE' ? (dataVoucher.voucherPriceDF ?? '') : ''}
                                                                        onChange={(e) => {
                                                                            const value = e.target.value?.replace(/[^0-9]/g, '') || ''
                                                                            const voucherPriceNum = Number(dataVoucher.voucherPrice) || 0
                                                                            const maxDf = voucherPriceNum
                                                                            const capped = value === '' ? '' : String(Math.min(Number(value), maxDf))
                                                                            const dfNum = capped === '' ? 0 : Number(capped)
                                                                            const cfAuto = String(Math.max(0, voucherPriceNum - dfNum))
                                                                            setDataVoucher({ ...dataVoucher, voucherPriceDF: capped, voucherPriceCF: cfAuto })
                                                                            setErrorMessage({ ...errorMessage, DF_CF_BAHT: '' })
                                                                        }}
                                                                        disabled={voucherId !== 0 || dataVoucher.voucherUsage !== 'OPERATIVE'}
                                                                    />
                                                                </Box>
                                                                <Typography>{t('VOUCHER.FORM.BAHT')}</Typography>
                                                            </Box>
                                                            <Box display="flex" alignItems="center" gap="8px">
                                                                <Box width="100px">
                                                                    <TextInput
                                                                        label={t('VOUCHER.FORM.CF_BAHT')}
                                                                        numberOnly
                                                                        value={dataVoucher.voucherUsage === 'OPERATIVE' ? (dataVoucher.voucherPriceCF ?? '') : ''}
                                                                        onChange={() => undefined}
                                                                        disabled
                                                                    />
                                                                </Box>
                                                                <Typography>{t('VOUCHER.FORM.BAHT')}</Typography>
                                                            </Box>
                                                        </Box>
                                                        {errorMessage.DF_CF_BAHT && (
                                                            <Typography fontSize="12px" color="error" sx={{ mt: 0.5 }}>{errorMessage.DF_CF_BAHT}</Typography>
                                                        )}
                                                    </>
                                                )}
                                            </Box>
                                        )}
                                    </Box>
                                    )}

                                    {/* สินค้า/ยา */}
                                    {showPdOption && (
                                    <Box display="flex" alignItems="center" width="100%">
                                        <RadioButton
                                            name="subVoucherUsage"
                                            onChange={(e) => setDataVoucher({ ...dataVoucher, voucherUsage: e.target.value, voucherPriceDF: '', voucherPriceCF: '' })}
                                            sx={{ gap: '16px' }}
                                            value={dataVoucher.voucherUsage === 'PRODUCT' ? 'PRODUCT' : ''}
                                            options={[
                                                { label: t('VOUCHER.FORM.USAGE_LIST_PD'), value: 'PRODUCT', disabled: voucherId !== 0 },
                                            ]}
                                            disabled={voucherId !== 0}
                                        />
                                    </Box>
                                    )}
                                </Box>
                                    )
                                })()}
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={8}></Grid>
                    <Grid item xs={4}>
                        <Grid container alignItems="center">
                            <Grid item xs={6}>
                                <Typography fontSize="16px" fontWeight={400}>{t('VOUCHER.FORM.MINIMUM')}</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Grid container spacing="8px" alignItems="center">
                                    <Grid item xs={8}>
                                        <Box display="flex" flexDirection="row" alignItems="center" sx={{ '.MuiFormHelperText-root .MuiBox-root': { whiteSpace: 'nowrap' } }}>
                                            <TextInput
                                                required
                                                label={t('VOUCHER.FORM.MINIMUM_COST')}
                                                numberOnly
                                                value={dataVoucher.minimum || 0}
                                                onChange={(e) => {
                                                    setDataVoucher({ ...dataVoucher, minimum: e.target.value })
                                                    setErrorMessage({ ...errorMessage, "MINIMUM": '' })
                                                }}
                                                fullWidth
                                                helperText={errorMessage.MINIMUM}
                                                inputProps={{ value: dataVoucher.minimum }}
                                                disabled={voucherId !== 0}
                                            />
                                        </Box>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <Typography fontSize="16px" fontWeight={400}>{t('VOUCHER.FORM.BAHT')}</Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={8}></Grid>
                    <Grid item xs={12}>
                        <Box display="flex" flexDirection="column" gap="16px">
                            <Typography fontSize="16px" fontWeight={500}>{t('VOUCHER.FORM.INITIAL_GIFT_VOUCHER_QUANTITY')}</Typography>

                            {/* ตัวเลือกกำหนดเลข GV เอง (Form หลัก) */}
                            <RadioButton
                                name="main-voucher-code-type"
                                onChange={(e) => {
                                    const isCustom = e.target.value === 'custom'
                                    setMainIsCustomCode(isCustom)
                                    setErrorMessage({ ...errorMessage, 'QTY': '', 'MAIN_CUSTOMCODES': '', 'MAIN_CUSTOMCODES_MAX': '' })
                                }}
                                sx={{ gap: '16px' }}
                                value={mainIsCustomCode ? 'custom' : 'auto'}
                                options={[
                                    { label: t('VOUCHER.FORM.AUTO_CREATE'), value: 'auto', disabled: voucherId !== 0 },
                                    { label: t('VOUCHER.FORM.CUSTOM_CODE_LABEL'), value: 'custom', disabled: voucherId !== 0 }
                                ]}
                            />

                            {/* กรณีสร้างอัตโนมัติ */}
                            {!mainIsCustomCode && (
                                <Grid container>
                                    <Grid item xs={4}>
                                        <TextInput
                                            required
                                            label={t('VOUCHER.FORM.INITIAL_GIFT_VOUCHER_QUANTITY')}
                                            value={dataVoucher.qty}
                                            numberOnly
                                            onChange={(e) => {
                                                setDataVoucher({ ...dataVoucher, qty: e.target.value })
                                                setErrorMessage({ ...errorMessage, "QTY": '' })
                                            }}
                                            fullWidth
                                            helperText={errorMessage.QTY}
                                            inputProps={{ value: dataVoucher.qty }}
                                            disabled={voucherId !== 0}
                                        />
                                    </Grid>
                                </Grid>
                            )}

                            {/* กรณีกำหนดเลข GV เอง */}
                            {mainIsCustomCode && voucherId === 0 && (
                                <Box sx={{ bgcolor: '#F5F5F5', p: 2, borderRadius: 1 }}>
                                    {/* เลือกรูปแบบการกำหนดเลข */}
                                    <Box mb={2}>
                                        <RadioButton
                                            name="main-custom-code-mode"
                                            onChange={(e) => {
                                                setMainCustomCodeMode(e.target.value as 'manual' | 'running')
                                                setErrorMessage({})
                                            }}
                                            sx={{ gap: '16px' }}
                                            value={mainCustomCodeMode}
                                            options={[
                                                { label: 'Running Number', value: 'running' },
                                                { label: t('VOUCHER.FORM.MANUAL_ENTRY'), value: 'manual' }
                                            ]}
                                        />
                                    </Box>

                                    {/* Running Number Mode */}
                                    {mainCustomCodeMode === 'running' && (
                                        <Box>
                                            <Grid container spacing={2}>
                                                <Grid item xs={3}>
                                                    <TextInput
                                                        required
                                                        label={t('VOUCHER.FORM.PREFIX')}
                                                        value={mainRunningPrefix}
                                                        onChange={(e: any) => {
                                                            setMainRunningPrefix(e.target.value.toUpperCase())
                                                            setErrorMessage({ ...errorMessage, 'MAIN_RUNNING_PREFIX': '' })
                                                        }}
                                                        fullWidth
                                                        helperText={errorMessage.MAIN_RUNNING_PREFIX}
                                                        inputProps={{ value: mainRunningPrefix }}
                                                    />
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <TextInput
                                                        required
                                                        label={t('VOUCHER.FORM.DIGITS')}
                                                        value={mainRunningDigits}
                                                        numberOnly
                                                        onChange={(e: any) => {
                                                            setMainRunningDigits(Number(e.target.value?.replace(/[^0-9]/g, '')) || 6)
                                                        }}
                                                        fullWidth
                                                        inputProps={{ value: mainRunningDigits }}
                                                    />
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <TextInput
                                                        required
                                                        label={t('VOUCHER.FORM.START_NUMBER')}
                                                        value={mainRunningStart}
                                                        numberOnly
                                                        onChange={(e: any) => {
                                                            setMainRunningStart(Number(e.target.value?.replace(/[^0-9]/g, '')) || 1)
                                                            setErrorMessage({ ...errorMessage, 'MAIN_RUNNING_START': '', 'MAIN_RUNNING_MAX': '' })
                                                        }}
                                                        fullWidth
                                                        helperText={errorMessage.MAIN_RUNNING_START}
                                                        inputProps={{ value: mainRunningStart }}
                                                    />
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <TextInput
                                                        required
                                                        label={t('VOUCHER.FORM.END_NUMBER')}
                                                        value={mainRunningEnd}
                                                        numberOnly
                                                        onChange={(e: any) => {
                                                            setMainRunningEnd(Number(e.target.value?.replace(/[^0-9]/g, '')) || 100)
                                                            setErrorMessage({ ...errorMessage, 'MAIN_RUNNING_END': '', 'MAIN_RUNNING_MAX': '' })
                                                        }}
                                                        fullWidth
                                                        helperText={errorMessage.MAIN_RUNNING_END || errorMessage.MAIN_RUNNING_MAX}
                                                        inputProps={{ value: mainRunningEnd }}
                                                    />
                                                </Grid>
                                            </Grid>
                                            <Box mt={2} p={1.5} bgcolor="#E8F5E9" borderRadius={1}>
                                                <Typography fontSize="14px" fontWeight={500} color="#2E7D32">{t('VOUCHER.FORM.GV_EXAMPLE')}</Typography>
                                                <Typography fontSize="13px" color="#1B5E20">
                                                    {mainRunningPrefix}{mainRunningStart.toString().padStart(mainRunningDigits, '0')} - {mainRunningPrefix}{mainRunningEnd.toString().padStart(mainRunningDigits, '0')}
                                                </Typography>
                                                <Typography fontSize="12px" color="#808080" mt={0.5}>
                                                    {t('VOUCHER.FORM.ITEMS_COUNT', { count: mainRunningEnd >= mainRunningStart ? mainRunningEnd - mainRunningStart + 1 : 0 })}
                                                </Typography>
                                            </Box>
                                        </Box>
                                    )}

                                    {/* Manual Mode */}
                                    {mainCustomCodeMode === 'manual' && (
                                        <Box>
                                            <TextAreaInput
                                                required
                                                label={t('VOUCHER.FORM.CUSTOM_CODE_PLACEHOLDER')}
                                                value={mainCustomVoucherCodes}
                                                onChange={(e: any) => {
                                                    setMainCustomVoucherCodes(e.target.value)
                                                    setErrorMessage({ ...errorMessage, 'MAIN_CUSTOMCODES': '', 'MAIN_CUSTOMCODES_DUPLICATE': '', 'MAIN_CUSTOMCODES_MAX': '' })
                                                }}
                                                fullWidth
                                                inputProps={{ value: mainCustomVoucherCodes, rows: 5 }}
                                            />
                                            {(errorMessage.MAIN_CUSTOMCODES || errorMessage.MAIN_CUSTOMCODES_DUPLICATE || errorMessage.MAIN_CUSTOMCODES_MAX) && (
                                                <Typography color="error" fontSize="12px" mt={0.5}>
                                                    {errorMessage.MAIN_CUSTOMCODES || errorMessage.MAIN_CUSTOMCODES_DUPLICATE || errorMessage.MAIN_CUSTOMCODES_MAX}
                                                </Typography>
                                            )}
                                            <Typography fontSize="12px" color="#808080" mt={1}>
                                                {t('VOUCHER.FORM.ITEMS_COUNT', { count: mainCustomVoucherCodes ? mainCustomVoucherCodes.split(/[\n,]/).map(code => code.trim()).filter(code => code !== '').length : 0 })}
                                            </Typography>
                                        </Box>
                                    )}
                                </Box>
                            )}
                        </Box>
                    </Grid>
                    <Grid item xs={4}>
                        <DateInput
                            required
                            label={t('VOUCHER.FORM.DATE_START')}
                            onChange={(e) => {
                                setDataVoucher({ ...dataVoucher, startDate: format(e, 'yyyy-MM-dd'), endDate: '' })
                                setErrorMessage({ ...errorMessage, "STARTDATE": '', "DATE_RANGE": '' })
                            }}
                            value={dataVoucher.startDate}
                            fullWidth
                            onClear={(e) => {
                                e.stopPropagation()
                                setDataVoucher({ ...dataVoucher, startDate: '' })
                            }}
                            helperText={errorMessage.STARTDATE}
                            disabled={voucherId !== 0}
                            disabledDatePast
                            language="TH"
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <DateInput
                            required
                            label={t('VOUCHER.FORM.DATE_END')}
                            onChange={(e) => {
                                setDataVoucher({ ...dataVoucher, endDate: format(e, 'yyyy-MM-dd') })
                                setErrorMessage({ ...errorMessage, "ENDDATE": '', "DATE_RANGE": '' })
                            }}
                            value={dataVoucher.endDate}
                            fullWidth
                            onClear={(e) => {
                                e.stopPropagation()
                                setDataVoucher({ ...dataVoucher, endDate: '' })
                            }}
                            helperText={errorMessage.ENDDATE}
                            disabled={voucherId !== 0 || !dataVoucher.startDate}
                            startDate={dataVoucher?.startDate}
                            language="TH"
                        />
                    </Grid>
                    <Grid item xs={12} sx={{ marginTop: errorMessage.ENDDATE || errorMessage.STARTDATE || errorMessage.DATE_RANGE ? '8px' : '0px' }}>
                        {errorMessage.DATE_RANGE && <Typography color="error" fontSize="12px" sx={{ mb: 1 }}>{errorMessage.DATE_RANGE}</Typography>}
                        <TextAreaInput label={t('VOUCHER.FORM.DETAIL')} value={dataVoucher.detail} onChange={(e) => setDataVoucher({ ...dataVoucher, detail: e.target.value })} fullWidth inputProps={{ value: dataVoucher.detail }} disabled={voucherId !== 0} />
                    </Grid>
                    <Box border="1px solid" borderColor="#E5E5E5" width="100%" marginLeft="16px" marginTop="16px" />
                    <Grid item xs={12}>
                        <Typography fontSize="18px" fontWeight={500}>{t('VOUCHER.FORM.SETTING.TITLE')}</Typography>
                    </Grid>
                    <Grid item xs={4}>
                        <Box gap="16px">
                            <CheckboxButton onChange={(e) => {
                                setIsPrefixGV(e.target.checked)
                                setDataVoucher({ ...dataVoucher, voucherPrefix: '' })

                            }} label={t('VOUCHER.FORM.SETTING.PREFIX_ID')} disabled={voucherId !== 0} checked={isPrefixGV} />
                            <Tooltip title={t('VOUCHER.FORM.SETTING.PREFIX_ID_HOVER')} placement="right">
                                <InfoIcon sx={{ width: '24px', height: '24px', color: '#A8A8A8' }} />
                            </Tooltip>
                        </Box>
                    </Grid>
                    <Grid item xs={4}>
                        {isPrefixGV && <TextInput required label={t('VOUCHER.FORM.SETTING.PREFIX_ID_INPUT')} numberOrText onChange={(e) => setDataVoucher({ ...dataVoucher, voucherPrefix: e.target.value.toUpperCase() })} fullWidth helperText={errorMessage.VOUCHERPREFIX} maxLength={5} disabled={voucherId !== 0} inputProps={{ value: dataVoucher.voucherPrefix }} />}
                    </Grid>
                    <Grid item xs={4}></Grid>
                    <Grid item xs={4}>
                        <CheckboxButton onChange={(e) => {
                            setIsPatient(e.target.checked)
                            setDataVoucher({ ...dataVoucher, voucherGroups: [], voucherGroup: "ALL" })
                        }} label={t('VOUCHER.FORM.SETTING.PATIENT')} disabled={voucherId !== 0} checked={isPatient} />
                    </Grid>
                    <Grid item xs={4}>
                        {isPatient &&
                            <Box display="flex" flexDirection="row" gap="8px">
                                <SelectInput required label={t('VOUCHER.FORM.SETTING.GROUP_PATIENT')} onChange={(e) => {
                                    setDataVoucher({ ...dataVoucher, voucherGroups: [] })
                                    setSubGroup([])
                                    setGroupPatient(e.target.value)
                                    preparationPatient(e.target.value)
                                }} options={[{ name: 'Ranking Member', value: 'RANK' }, { name: t('VOUCHER.FORM.SETTING.TYPE_PATIENT'), value: 'PATIENT' }]} helperText={errorMessage.GROUPTYPE} disabled={voucherId !== 0} value={groupPatient} />
                                <SelectCheckBoxInput
                                    required
                                    label={t('VOUCHER.FORM.SETTING.SUB_GROUP')}
                                    onChange={(e) => {
                                        setSubGroup(e)
                                        setDataVoucher({ ...dataVoucher, voucherGroups: _.map(e, (item) => ({ groupType: groupPatient, groupTypeId: item })), voucherGroup: groupPatient })
                                    }
                                    }
                                    options={optionSubGroup}
                                    selected={subGroup}
                                    disabled={voucherId !== 0}
                                    helperText={errorMessage.GROUPTYPEID}
                                    tranformOption
                                />
                            </Box>
                        }
                    </Grid>
                    <Grid item xs={4}></Grid>
                    <Grid item xs={12}>
                        <CheckboxButton onChange={(e) => {
                            if (e.target.checked) {
                                setDataVoucher({ ...dataVoucher, connectPatient: "1" })
                            } else {
                                setDataVoucher({ ...dataVoucher, connectPatient: "0" })
                            }
                        }} label={t('VOUCHER.FORM.SETTING.USE_VOUCHER_DONT_PATIENT')} disabled={voucherId !== 0} checked={dataVoucher.connectPatient === "1"} />
                    </Grid>
                    <Grid item xs={12}>
                        <CheckboxButton onChange={(e) => {
                            if (e.target.checked) {
                                setDataVoucher({ ...dataVoucher, activationMode: 'MANUAL' })
                            } else {
                                setDataVoucher({ ...dataVoucher, activationMode: 'AUTO' })
                            }
                        }} label={t('VOUCHER.FORM.SETTING.MANUAL_ACTIVATION')} disabled={voucherId !== 0} checked={dataVoucher.activationMode === 'MANUAL'} />
                    </Grid>
                </Grid>
            </Box>

            <PageModal
                isOpen={isOpenPageModal}
                title={t('VOUCHER.FORM.MODAL.TITLE')}
                size="S"
                onSubmit={{ onClick: onCreateVoucherModal }}
                onCancel={{
                    onClick: () => {
                        setDataStartDate(dataVoucher?.startDate)
                        setDataEndDate(dataVoucher?.endDate)
                        setErrorMessage({})
                        setIsOpenPageModal(false)
                        setIsCustomCode(false)
                        setCustomVoucherCodes('')
                        setCustomCodeMode('running')
                        setRunningStart(1)
                        setRunningEnd(100)
                    }
                }}
                handleClose={() => {
                    setDataStartDate(dataVoucher?.startDate)
                    setDataEndDate(dataVoucher?.endDate)
                    setErrorMessage({})
                    setIsOpenPageModal(false)
                    setIsCustomCode(false)
                    setCustomVoucherCodes('')
                    setCustomCodeMode('running')
                    setRunningStart(1)
                    setRunningEnd(100)
                }}
            >
                <Box display="flex" flexDirection="column" gap="16px" >
                    <Typography fontSize="16px" fontWeight={400} >{t('VOUCHER.FORM.MODAL.LOTNUMBER')} {handleLotNumber(optionLotNumber)}</Typography>

                    {/* ตัวเลือกกำหนดเลข GV เอง */}
                    <Box>
                        <RadioButton
                            name="voucher-code-type"
                            onChange={(e) => {
                                const isCustom = e.target.value === 'custom'
                                setIsCustomCode(isCustom)
                                setErrorMessage({ ...errorMessage, 'VOUCHERTOTAL': '', 'CUSTOMCODES': '', 'CUSTOMCODES_MAX': '' })
                            }}
                            sx={{ gap: '16px' }}
                            value={isCustomCode ? 'custom' : 'auto'}
                            options={[
                                { label: t('VOUCHER.FORM.AUTO_CREATE'), value: 'auto' },
                                { label: t('VOUCHER.FORM.CUSTOM_CODE_LABEL'), value: 'custom' }
                            ]}
                        />
                    </Box>

                    {/* กรณีสร้างอัตโนมัติ */}
                    {!isCustomCode && (
                        <TextInput
                            required
                            label={t('VOUCHER.FORM.MODAL.VOUCHER_AMOUNT')}
                            value={voucherTotal}
                            onChange={(e: any) => {
                                const MAX_VOUCHER_TOTAL = 2000
                                const rawValue = e.target.value?.replace(/[^0-9]/g, '') || ''
                                const parsedValue = Number(rawValue || 0)
                                const nextValue = Math.min(parsedValue, MAX_VOUCHER_TOTAL)
                                setVoucherTotal(nextValue)
                                setErrorMessage({
                                    ...errorMessage,
                                    VOUCHERTOTAL: parsedValue > MAX_VOUCHER_TOTAL ? t('VOUCHER.FORM.MODAL.ERROR_MAX_LENGTH') : ''
                                })
                            }}
                            fullWidth
                            helperText={errorMessage.VOUCHERTOTAL}
                        />
                    )}

                    {/* กรณีกำหนดเลข GV เอง */}
                    {isCustomCode && (
                        <Box>
                            {/* เลือกรูปแบบการกำหนดเลข */}
                            <Box mb={2}>
                                <RadioButton
                                    name="custom-code-mode"
                                    onChange={(e) => {
                                        setCustomCodeMode(e.target.value as 'manual' | 'running')
                                        setErrorMessage({})
                                    }}
                                    sx={{ gap: '16px' }}
                                    value={customCodeMode}
                                    options={[
                                        { label: 'Running Number', value: 'running' },
                                        { label: t('VOUCHER.FORM.MANUAL_ENTRY'), value: 'manual' }
                                    ]}
                                />
                            </Box>

                            {/* Running Number Mode */}
                            {customCodeMode === 'running' && (
                                <Box sx={{ bgcolor: '#F5F5F5', p: 2, borderRadius: 1 }}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={6}>
                                            <TextInput
                                                required
                                                label={t('VOUCHER.FORM.PREFIX')}
                                                value={runningPrefix}
                                                onChange={(e: any) => {
                                                    setRunningPrefix(e.target.value.toUpperCase())
                                                    setErrorMessage({ ...errorMessage, 'RUNNING_PREFIX': '' })
                                                }}
                                                fullWidth
                                                helperText={errorMessage.RUNNING_PREFIX}
                                                inputProps={{ value: runningPrefix }}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextInput
                                                required
                                                label={t('VOUCHER.FORM.DIGITS')}
                                                value={runningDigits}
                                                numberOnly
                                                onChange={(e: any) => {
                                                    setRunningDigits(Number(e.target.value?.replace(/[^0-9]/g, '')) || 6)
                                                }}
                                                fullWidth
                                                inputProps={{ value: runningDigits }}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextInput
                                                required
                                                label={t('VOUCHER.FORM.START_NUMBER')}
                                                value={runningStart}
                                                numberOnly
                                                onChange={(e: any) => {
                                                    setRunningStart(Number(e.target.value?.replace(/[^0-9]/g, '')) || 1)
                                                    setErrorMessage({ ...errorMessage, 'RUNNING_START': '', 'RUNNING_MAX': '' })
                                                }}
                                                fullWidth
                                                helperText={errorMessage.RUNNING_START}
                                                inputProps={{ value: runningStart }}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextInput
                                                required
                                                label={t('VOUCHER.FORM.END_NUMBER')}
                                                value={runningEnd}
                                                numberOnly
                                                onChange={(e: any) => {
                                                    setRunningEnd(Number(e.target.value?.replace(/[^0-9]/g, '')) || 100)
                                                    setErrorMessage({ ...errorMessage, 'RUNNING_END': '', 'RUNNING_MAX': '' })
                                                }}
                                                fullWidth
                                                helperText={errorMessage.RUNNING_END || errorMessage.RUNNING_MAX}
                                                inputProps={{ value: runningEnd }}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Box mt={2} p={1.5} bgcolor="#E8F5E9" borderRadius={1}>
                                        <Typography fontSize="14px" fontWeight={500} color="#2E7D32">{t('VOUCHER.FORM.GV_EXAMPLE')}</Typography>
                                        <Typography fontSize="13px" color="#1B5E20">
                                            {runningPrefix}{runningStart.toString().padStart(runningDigits, '0')} - {runningPrefix}{runningEnd.toString().padStart(runningDigits, '0')}
                                        </Typography>
                                        <Typography fontSize="12px" color="#808080" mt={0.5}>
                                            {t('VOUCHER.FORM.ITEMS_COUNT', { count: runningEnd >= runningStart ? runningEnd - runningStart + 1 : 0 })}
                                        </Typography>
                                    </Box>
                                </Box>
                            )}

                            {/* Manual Mode */}
                            {customCodeMode === 'manual' && (
                                <Box>
                                    <TextAreaInput
                                        required
                                        label={t('VOUCHER.FORM.CUSTOM_CODE_PLACEHOLDER')}
                                        value={customVoucherCodes}
                                        onChange={(e: any) => {
                                            setCustomVoucherCodes(e.target.value)
                                            setErrorMessage({ ...errorMessage, 'CUSTOMCODES': '', 'CUSTOMCODES_MAX': '' })
                                        }}
                                        fullWidth
                                        inputProps={{ value: customVoucherCodes, rows: 5 }}
                                    />
                                    {(errorMessage.CUSTOMCODES || errorMessage.CUSTOMCODES_MAX) && (
                                        <Typography color="error" fontSize="12px" mt={0.5}>
                                            {errorMessage.CUSTOMCODES || errorMessage.CUSTOMCODES_MAX}
                                        </Typography>
                                    )}
                                    <Typography fontSize="12px" color="#808080" mt={1}>
                                        {t('VOUCHER.FORM.ITEMS_COUNT', { count: customVoucherCodes ? parseManualVoucherCodes(customVoucherCodes).length : 0 })}
                                    </Typography>
                                </Box>
                            )}
                        </Box>
                    )}

                    <DateInput
                        required
                        label={t('VOUCHER.FORM.MODAL.START_DATE')}
                        onChange={(e) => {
                            setDataStartDate(format(e, 'yyyy-MM-dd'))
                            setDataEndDate('')
                            setErrorMessage({ ...errorMessage, 'DATASTARTDATE': '' })
                        }}
                        onClear={(e) => {
                            e.stopPropagation()
                            setDataStartDate('')
                        }}
                        value={dataStartDate}
                        fullWidth
                        disabledDatePast
                        helperText={errorMessage.DATASTARTDATE}
                        language="TH"
                    />
                    <DateInput
                        required
                        label={t('VOUCHER.FORM.MODAL.END_DATE')}
                        onChange={(e) => {
                            setDataEndDate(format(e, 'yyyy-MM-dd'))
                            setErrorMessage({ ...errorMessage, 'DATASENDDATE': '' })
                        }}
                        onClear={(e) => {
                            e.stopPropagation()
                            setDataEndDate('')
                        }}
                        value={dataEndDate}
                        fullWidth
                        startDate={dataStartDate}
                        helperText={errorMessage.DATAENDDATE}
                        language="TH"
                    />
                </Box>
            </PageModal>

            <AlertModal
                isOpen={isDelete}
                title={t(`VOUCHER.FORM.MESSAGE.${statusDelete === 'UNLINK' ? 'UNLINK_TITLE' : 'DELETE_TITLE'}`)}
                message={t(`VOUCHER.FORM.MESSAGE.${statusDelete === 'UNLINK' ? 'UNLINK_MESSAGE' : 'DELETE_MESSAGE'}`, { name: name ? name : `(${isChecks.length} ${t('VOUCHER.FORM.MESSAGE.LIST')})` })}
                type={statusDelete === 'UNLINK' ? 'warning' : 'error'}
                onSubmit={{ onClick: () => name ? deleteTableList(voucherListId) : deleteTableList(), title: t('VOUCHER.FORM.MESSAGE.BUTTON_SAVE_DELETE') }}
                onCancel={{
                    onClick: () => {
                        setName('')
                        setIsDelete(false)
                        setErrorMessage({})
                    }, title: t('VOUCHER.FORM.MESSAGE.BUTTON_CANCEL')
                }}
                handleClose={() => {
                    setName('')
                    setIsDelete(false)
                    setErrorMessage({})
                }}
            />
            <AlertModal
                isOpen={alertActivationModal}
                title={getActivationModalTitle()}
                message={getActivationModalMessage()}
                type="warning"
                onSubmit={{ onClick: onConfirmActivation, title: t('VOUCHER.LOT.CONFIRM') }}
                onCancel={{ onClick: () => { setAlertActivationModal(false); setActivationAction(null) }, title: t('VOUCHER.MESSAGE.BUTTON_CANCEL') }}
                handleClose={() => { setAlertActivationModal(false); setActivationAction(null) }}
            />

            {voucherId !== 0 && location.pathname === "/voucher/update" &&
                <>
                    <Box marginTop="24px" boxShadow="0px 0px 12px 0px #CCCCCC;" borderRadius="8px" paddingX="32px" paddingY="24px">
                        <Box display="flex" justifyContent="space-between" alignItems="center" >
                            <Typography fontSize="24px" fontWeight={500}>{t('VOUCHER.FORM.LIST_VOUCHER_ID')}</Typography>
                            <Box display="flex" flexDirection="row" gap="16px">
                                <ButtonExport
                                    headCells={headCells}
                                    portrait={true}
                                    filter={''}
                                    fileName={t('VOUCHER.FORM.EXPORT_FILENAME')}
                                    rowsData={dataVoucherListExport.map((item: any, index: number) => {
                                        return renderDataVoucher(item, index, true)
                                    })}
                                    marginPrint={'0.5cm'}
                                    componentExportRef={componentExportRef}
                                />
                                <MainButton
                                    onClick={() => setIsOpenPageModal(true)}
                                    title={t('VOUCHER.FORM.ADD_UNIT_VOUCHER')}
                                    type="primary"
                                    variant="outlined"
                                    startIcon={<AddCircleIcon />}
                                    style={{ height: '40px' }}
                                />
                            </Box>
                        </Box>

                        <Grid container>
                            <Grid item xs={1}>
                                <Typography color="#29302E" fontSize="16px" fontWeight={500}>{t('VOUCHER.FORM.STATUS')}</Typography>
                            </Grid>
                            <Grid item xs={2}>
                                <Box display="flex" flexDirection="row" alignItems="center" gap="24px">
                                    <Typography color="#EDBA07" fontSize="16px" fontWeight={400}>{t('VOUCHER.FORM.STATUS_WAITING')}</Typography>
                                    <Typography fontSize="16px" fontWeight={400}>{countWaiting || 0}/{totalCount}</Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={2}>
                                <Box display="flex" flexDirection="row" alignItems="center" gap="24px">
                                    <Typography color="#1CB99A" fontSize="16px" fontWeight={400}>{t('VOUCHER.FORM.STATUS_READY')}</Typography>
                                    <Typography fontSize="16px" fontWeight={400}>{countReady || 0}/{totalCount}</Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={2}>
                                <Box display="flex" flexDirection="row" alignItems="center" gap="24px">
                                    <Typography color="#5A5A5A" fontSize="16px" fontWeight={400}>{t('VOUCHER.FORM.STATUS_USED')}</Typography>
                                    <Typography fontSize="16px" fontWeight={400}>{countUsed || 0}/{totalCount}</Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={2}>
                                <Box display="flex" flexDirection="row" alignItems="center" gap="24px">
                                    <Typography color="#B00020" fontSize="16px" fontWeight={400}>{t('VOUCHER.FORM.STATUS_EXPIRED')}</Typography>
                                    <Typography fontSize="16px" fontWeight={400}>{countExpired || 0}/{totalCount}</Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={3}></Grid>
                        </Grid>

                        {isFormManualMode && (
                            <Box marginTop="16px">
                                <Box display="flex" alignItems="center" gap="8px" marginBottom="12px">
                                    <Typography fontSize="14px" fontWeight={500} color="#1CB99A">{t('VOUCHER.LOT.MODE_MANUAL')}</Typography>
                                </Box>
                                {optionLotNumber?.length > 0 && (
                                    <Box border="1px solid #E5E5E5" borderRadius="8px" padding="16px" marginBottom="8px">
                                        <Typography fontSize="16px" fontWeight={500} marginBottom="12px">{t('VOUCHER.LOT.TITLE')}</Typography>
                                        <Box display="flex" flexWrap="wrap" gap="12px">
                                            {optionLotNumber.map((lot: any) => (
                                                <Box key={lot.id} display="flex" alignItems="center" gap="8px" border="1px solid #E5E5E5" borderRadius="4px" padding="8px 16px">
                                                    <Typography fontSize="14px" fontWeight={500}>Lot {lot.name}</Typography>
                                                    <MainButton
                                                        onClick={() => handleActivation('LOT', 'ACTIVATE', lot.id)}
                                                        title={t('VOUCHER.LOT.ACTIVATE')}
                                                        type="primary"
                                                        variant="contained"
                                                        style={{ height: '32px', fontSize: '13px' }}
                                                        startIcon={<PlayCircleOutlineIcon sx={{ fontSize: '18px' }} />}
                                                        disabled={activationLoading}
                                                    />
                                                    <MainButton
                                                        onClick={() => handleActivation('LOT', 'DEACTIVATE', lot.id)}
                                                        title={t('VOUCHER.LOT.DEACTIVATE')}
                                                        type="secondary"
                                                        variant="outlined"
                                                        style={{ height: '32px', fontSize: '13px' }}
                                                        startIcon={<PauseCircleOutlineIcon sx={{ fontSize: '18px' }} />}
                                                        disabled={activationLoading}
                                                    />
                                                </Box>
                                            ))}
                                        </Box>
                                    </Box>
                                )}
                            </Box>
                        )}

                        <Grid container spacing="16px" marginTop="0px">
                            <Grid item xs={4}>
                                <Grid container spacing="16px">
                                    <Grid item xs={6}>
                                        <TextInput label={t('VOUCHER.FORM.SEARCH')} onChange={(e) => setSearch(e.target.value)} fullWidth value={search} inputProps={{ endAdornment: search && <InputAdornment position="end"><Box sx={{ cursor: 'pointer' }} onClick={() => setSearch('')}><ClearIcon /></Box></InputAdornment> }} />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <SelectCheckBoxInput
                                            label={t('VOUCHER.FORM.STATUS_FITTER.STATUS')}
                                            onChange={(e) => {
                                                setStatus(e)
                                                const result = e.join(',')
                                                setResultStatus(result)
                                            }}
                                            options={[
                                                { name: t('VOUCHER.FORM.STATUS_FITTER.WAITING'), id: 'WAITING', },
                                                { name: t('VOUCHER.FORM.STATUS_FITTER.READY'), id: 'READY', },
                                                { name: t('VOUCHER.FORM.STATUS_FITTER.USED'), id: 'USED', },
                                                { name: t('VOUCHER.FORM.STATUS_FITTER.EXPIRED'), id: 'EXPIRED' }
                                            ]}
                                            selected={status || []}
                                        />
                                    </Grid>
                                </Grid>

                            </Grid>
                            <Grid item xs={4} >
                                <Grid container spacing="16px">
                                    <Grid item xs={6}>
                                        <SelectCheckBoxInput
                                            label={t('VOUCHER.FORM.LOTNUMBER')}
                                            onChange={(e) => {
                                                setLotNumber(e)
                                                const result = e.join(',')
                                                setResultLotNumber(result)
                                            }}
                                            options={optionLotNumber}
                                            selected={lotNumber}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <DateRangeInput
                                            inputHeight={40}
                                            value={rangeDate || ['', '']}
                                            onchange={(val: any) => {
                                                if (_.isEmpty(val)) setRangeDate(['', ''])
                                                else setRangeDate([moment(val[0]).format('YYYY-MM-DD'), moment(val[1]).format('YYYY-MM-DD')])
                                            }}
                                            label={''}
                                            allowClear
                                            onClear={() => setRangeDate(['', ''])}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={4}>
                                <Box display="flex" justifyContent="space-between" >
                                    <MainButton onClick={() => {
                                        setPage(1)
                                        preparationVoucherId(voucherId, 1)
                                        preparationVoucherId(voucherId, 1, true)
                                    }} title={t('VOUCHER.FORM.SEARCH_VOUCHER_LIST')} type="primary" variant="contained" />
                                    <SelectPrimaryInput buttonLabel={t('VOUCHER.FORM.BULK_ACTIONS')} disabled={isChecks.length === 0} options={[
                                        ...(isFormManualMode ? [
                                            {
                                                label: t('VOUCHER.BULK.ACTIVATE'), onClick: () => handleActivation('BULK', 'ACTIVATE'),
                                                icon: <PlayCircleOutlineIcon sx={{ color: '#808080' }} />
                                            },
                                            {
                                                label: t('VOUCHER.BULK.DEACTIVATE'), onClick: () => handleActivation('BULK', 'DEACTIVATE'),
                                                icon: <PauseCircleOutlineIcon sx={{ color: '#808080' }} />
                                            },
                                        ] : []),
                                        {
                                            label: t('VOUCHER.FORM.ACTION_UNLINK'), onClick: () => {
                                                setStatusDelete('UNLINK')
                                                setIsDelete(true)
                                            }, icon: <LinkOffIcon sx={{ color: '#808080' }} />
                                            , disabled: _.filter(_.map(isChecks, (check) => _.find(dataVoucherList, (item) => item.voucherListId === check)), (data) => data?.status === 'USED')?.length === 1
                                        },
                                        {
                                            label: t('VOUCHER.FORM.ACTION_DELETE'), onClick: () => {
                                                setStatusDelete('DELETED')
                                                setIsDelete(true)
                                            }, icon: <DeleteOutlineOutlinedIcon sx={{ color: '#808080' }} />,
                                            disabled: hasNonWaitingSelected
                                        }
                                    ]} />
                                    {/* <MainButton onClick={() => setIsDelete(true)} title={t('VOUCHER.FORM.BUTTON_DELETE_VOUCHER_ALL')} type="danger" variant="outlined" startIcon={<DeleteOutlineIcon />} disabled={isChecks.length === 0} /> */}
                                </Box>
                            </Grid>
                        </Grid>

                        <Box marginTop="16px" >
                            <TableCustom
                                headCells={headCells}
                                onSort={(sortByVal: string, sortTypeVal: string) => {
                                    setSortType(sortTypeVal)
                                    setSortBy(sortByVal)
                                }}
                                page={page}
                                pageLimit={pageLimit}
                                rowsData={dataVoucherList.map((item: any, index: number) => {
                                    return renderData(item, index)
                                })}
                                setPage={(e) => setPage(e)}
                                setPageLimit={(e) => setPageLimit(e)}
                                sortBy={sortBy}
                                sortType={sortType}
                                rowCount={rowCount}

                            />
                        </Box>
                    </Box>
                    <Box className={`print-show`} ref={componentExportRef}>
                        <Box fontSize={'10px'} fontWeight={'600'}>{t('VOUCHER.FORM.LIST_VOUCHER_ID')}</Box>
                        <Box fontSize={'10px'} display="flex" flexDirection="row" alignItems="center" gap="8px">
                            <Typography fontSize="10px" fontWeight="700px">{t('VOUCHER.FORM.VOUCHER_NAME_LABEL')}</Typography>
                            <Typography fontSize="10px" fontWeight="400px">{dataVoucher?.voucherName}</Typography>
                        </Box>
                        <Box fontSize={'10px'} fontWeight={'500'} display={'flex'} gap={'8px'} marginBottom={'8px'}>
                            <span>
                                {t('VOUCHER.FORM.SEARCH_VOUCHER_LIST')}: {search || '-'}
                            </span>
                            <span>
                                {t('VOUCHER.FORM.STATUS')}: {_.map(status, (item: string) => statusType(item))?.join(", ") || '-'}
                            </span>
                            <span>
                                {t('VOUCHER.FORM.DATE_START')}: {moment(dataVoucher.startDate).format('DD/MM/YYYY') || '-'}
                            </span>
                            <span>
                                {t('VOUCHER.FORM.DATE_END')}: {moment(dataVoucher.endDate).format('DD/MM/YYYY') || '-'}
                            </span>
                        </Box>
                        <Box
                            width={'100%'}
                            marginBottom={'8px'}
                            sx={{
                                '.no-link': { display: 'flex', justifyContent: 'center', gap: '4px' },
                                'th,td': {
                                    fontSize: '8px',
                                    margin: '0',
                                    padding: '1px',
                                    borderBottom: '1px solid black',
                                    borderTop: '1px solid black',
                                    textAlign: 'center',
                                    ':last-child': {
                                        borderRight: 0,
                                    }
                                }
                            }}
                        >
                            <table style={{ tableLayout: 'fixed', borderCollapse: 'collapse', minWidth: '100%', maxWidth: '100%' }}>
                                <thead>
                                    {_.map(headCells.filter((headCell: any) => headCell.id !== 'action' && headCell.id !== 'voucherSelect' && headCell.id !== 'UpdatedAt'), (val: any, index: number) => {
                                        return (
                                            <th
                                                style={{
                                                    textAlign: val.align ? val.align : 'left',
                                                    fontSize: 8,
                                                    fontWeight: 500
                                                }}>
                                                {val.label || (val.labelKey)}
                                            </th>
                                        )
                                    })}
                                </thead>
                                <tbody>
                                    {dataVoucherListExport?.length ? dataVoucherListExport?.map((item: any, index: number) => {
                                        return renderDataVoucher(item, index, true)
                                    }) : []}
                                    {!dataVoucherListExport?.length && (
                                        <td colSpan={headCells.length}>
                                            {t('VOUCHER.FORM.NO_OPTIONS')}
                                        </td>
                                    )}
                                </tbody>
                            </table>
                        </Box>
                    </Box>
                </>
            }
        </Box>
    )
}


export default FormVoucher